/* ============================================================
   WowSticker — interactions
   ============================================================ */
(function(){
  'use strict';

  /* ---------- Header scroll state ---------- */
  const header = document.querySelector('.header');
  const onScroll = () => header && header.classList.toggle('scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onScroll, { passive:true }); onScroll();

  /* ---------- Galleria mobile: crossfade sfalsato immagini ---------- */
  (function(){
    var grid = document.getElementById('galGrid');
    if(!grid || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var imgs = [].slice.call(grid.querySelectorAll('.gal-card img'));
    if(imgs.length < 3) return;
    var pool = imgs.map(function(im){ return { src: im.getAttribute('src'), alt: im.getAttribute('alt') || '' }; });
    imgs.forEach(function(im){ im.style.transition = 'opacity .6s ease'; });
    function swap(im){
      var cur = im.getAttribute('src');
      var opts = pool.filter(function(p){ return p.src !== cur; });
      if(!opts.length) return;
      var pick = opts[Math.floor(Math.random()*opts.length)];
      im.style.opacity = '0';
      setTimeout(function(){
        im.setAttribute('src', pick.src);
        im.setAttribute('alt', pick.alt);
        im.style.opacity = '1';
      }, 600);
    }
    var step = 2700;
    imgs.forEach(function(im, i){
      setTimeout(function(){ setInterval(function(){ swap(im); }, 8000); }, i * step);
    });
  })();

  (function(){
    var promo = document.querySelector('.promo');
    if(!promo) return;
    var items = [].slice.call(promo.querySelectorAll('.promo-item'));
    if(items.length < 2) return;
    var mq = window.matchMedia('(max-width:760px)');
    var i = 0, timer = null;
    function show(n){ items.forEach(function(el,k){ el.classList.toggle('is-active', k===n); }); }
    function start(){
      if(timer) return;
      i = 0; show(0);
      timer = setInterval(function(){ i = (i+1) % items.length; show(i); }, 8000);
    }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } items.forEach(function(el){ el.classList.remove('is-active'); }); }
    function sync(){ if(mq.matches) start(); else stop(); }
    (mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync));
    sync();
  })();

  /* ---------- Hero background slideshow (auto-rotate + theme swap) ---------- */
  (function heroSlider(){
    const hero = document.querySelector('.hero');
    if(!hero) return;
    const slides = Array.from(hero.querySelectorAll('.hero-slide'));
    const dots = Array.from(hero.querySelectorAll('.hero-dot'));
    if(slides.length < 2) return;
    let i = 0, timer = null;
    const DELAY = 5500;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s,idx)=> s.classList.toggle('is-active', idx===i));
      dots.forEach((d,idx)=> d.classList.toggle('is-active', idx===i));
      hero.setAttribute('data-theme', slides[i].getAttribute('data-theme') || 'light');
    };
    const play = () => { stop(); timer = setInterval(()=> go(i+1), DELAY); };
    const stop = () => { if(timer){ clearInterval(timer); timer = null; } };
    dots.forEach((d,idx)=> d.addEventListener('click', ()=>{ go(idx); play(); }));
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
  })();

  /* ---------- Mobile drawer ---------- */
  const drawer = document.getElementById('drawer');
  const openDrawer = () => drawer && drawer.classList.add('open');
  const closeDrawer = () => drawer && drawer.classList.remove('open');
  document.querySelectorAll('[data-open-menu]').forEach(b=>b.addEventListener('click', openDrawer));
  document.querySelectorAll('[data-close-menu]').forEach(b=>b.addEventListener('click', closeDrawer));

  /* ---------- Smooth anchor + close drawer ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(a=>{
    a.addEventListener('click', e=>{
      const id = a.getAttribute('href');
      if(id.length>1){
        const t = document.querySelector(id);
        if(t){ e.preventDefault(); closeDrawer();
          let y;
          if(id === '#wow-assistant'){
            // center the WOWassistant chat in the viewport
            const r = t.getBoundingClientRect();
            y = r.top + window.scrollY - Math.max(70, (window.innerHeight - r.height) / 2);
          } else {
            y = t.getBoundingClientRect().top + window.scrollY - 70;
          }
          window.scrollTo({ top:y, behavior:'smooth' });
        }
      }
    });
  });

  /* ---------- Reveal on scroll ---------- */
  const io = new IntersectionObserver((es)=>{
    es.forEach(en=>{ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }});
  }, { threshold:0.12, rootMargin:'0px 0px -8% 0px' });
  document.querySelectorAll('.reveal').forEach((el,i)=>{
    el.style.transitionDelay = (Math.min(i%4,3)*70)+'ms';
    io.observe(el);
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq-item').forEach(item=>{
    const q = item.querySelector('.faq-q');
    const a = item.querySelector('.faq-a');
    q.addEventListener('click', ()=>{
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(o=>{ o.classList.remove('open'); o.querySelector('.faq-a').style.maxHeight=null; });
      if(!isOpen){ item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  /* ============================================================
     CONFIGURATOR
     ============================================================ */
  const cfg = document.getElementById('config');
  if(!cfg) return;

  const C = window.WowCatalog;
  const ETA = { 50:'3–5 giorni', 100:'3–5 giorni', 200:'4–6 giorni', 300:'4–6 giorni', 500:'5–7 giorni', 1000:'6–9 giorni', 2000:'7–12 giorni' };

  const state = { tipo:null, tipoLabel:null, taglio:null, taglioLabel:null, bordoBianco:false, sfondoIncluso:null, size:null, sizeLabel:null, customW:null, customH:null, qty:null, orientamento:'landscape', orientTouched:false, file:false, originalFileUrls:[], previewFileUrls:[] };
  // Product mode: material is fixed by the product (data-tipo on #config), no material step.
  const fixedTipo = cfg.getAttribute('data-tipo'); function presTooSmall(){ return fixedTipo==='prespaziato' && state.size==='custom' && state.customW>0 && state.customH>0 && state.customW*state.customH<49; }
  const productMode = !!fixedTipo;
  const prodDef = (C && fixedTipo) ? C.PRODUCTS.filter(function(p){ return p.key===fixedTipo; })[0] : null;
  const bigFormat = !!(prodDef && prodDef.bigFormat);
  if(productMode && C && C.TIPO_LABEL[fixedTipo]){
    state.tipo = fixedTipo;
    state.tipoLabel = C.TIPO_LABEL[fixedTipo];
    if(fixedTipo==='dtf'){ state.taglio='dtf'; state.taglioLabel='Foglio DTF'; }
    if(fixedTipo==='prespaziato'){ state.taglio='vinyl'; state.taglioLabel='Prespaziato'; ['3x3','5x3','5x5','7x5'].forEach(function(v){ var b=cfg.querySelector('.opt[data-group="size"][data-value="'+v+'"]'); if(b) b.remove(); }); }
    if(fixedTipo==='stampataglio'){ state.taglio='stampataglio'; state.taglioLabel='Aderente al profilo · lettera per lettera'; }
    if(bigFormat){
      // grande formato: dimensione solo su misura (al m²); il taglio resta a scelta
      state.size='custom'; state.sizeLabel='Su misura';
      var szSub = cfg.querySelector('.step-panel[data-req="size"] .step-sub');
      if(szSub) szSub.textContent = 'Imposta larghezza e altezza: il prezzo è calcolato al m².';
      // grande formato: quantità realistiche (1 pezzo in su), non i lotti da 50
      var qg = cfg.querySelector('.qty-grid-real');
      if(qg){
        var BQ = [[1,'1 pezzo'],[2,'\u00a0'],[3,'\u00a0'],[5,'popolare'],[10,'conviene'],[25,'\u00a0'],[50,'ingrosso']];
        qg.innerHTML = BQ.map(function(o){ return '<button class="opt qty-opt" data-group="qty" data-value="'+o[0]+'"><span class="opt-t">'+o[0]+'</span><span class="opt-d">'+o[1]+'</span><span class="opt-check">\u2713</span></button>'; }).join('');
      }
      var qSub = cfg.querySelector('.step-panel[data-req="qty"] .step-sub');
      if(qSub) qSub.textContent = 'Prezzo al m²: indica quante copie ti servono di questo formato.';
      var qNote = cfg.querySelector('.qty-note');
      if(qNote) qNote.hidden = true;
    }
    // the first step is "Taglio" by default — relabel the pip for materials that repurpose it
    var pip1 = cfg.querySelector('.step-pip:first-child .t');
    if(pip1){ if(fixedTipo==='prespaziato') pip1.textContent='Colore'; else if(fixedTipo==='stampataglio') pip1.textContent='Taglio'; }
  }
  const firstStep = productMode ? 0 : 1;
  // Pre-selected cut (taglio) option, if any — skipped for DTF & Prespaziati (no cut step)
  const preTaglio = (fixedTipo!=='dtf' && fixedTipo!=='prespaziato' && fixedTipo!=='stampataglio') ? cfg.querySelector('.opt[data-group="taglio"].sel') : null;
  if(preTaglio){ state.taglio = preTaglio.getAttribute('data-value'); state.taglioLabel = preTaglio.getAttribute('data-label') || preTaglio.querySelector('.opt-t').textContent; }

  /* Colori prespaziato.
     Fonte reale: opzione prodotto "Colore" di Shopify, iniettata dal tema come
     window.WOW_VINYL_COLORS = [{ id, name, img, hex }] dove img è la foto colore
     1000×1000 caricata sul valore variante. Se manca, si usa questa palette
     di riserva con i colori più comuni. */
  const VINYL_FALLBACK = [
    {id:'bianco',name:'Bianco',hex:'#f4f4f2'}, {id:'nero',name:'Nero',hex:'#141414'},
    {id:'oro',name:'Oro',hex:'#c9a227',metal:true,hex2:'#f7e9ad'}, {id:'argento',name:'Argento',hex:'#9a9ea3',metal:true,hex2:'#edf1f4'},
    {id:'rosso',name:'Rosso',hex:'#d11f26'}, {id:'rosso-scuro',name:'Rosso scuro',hex:'#7c1418'},
    {id:'blu',name:'Blu',hex:'#1f6fd0'}, {id:'navy',name:'Blu navy',hex:'#16233f'}
  ];
  function slugColor(s){ return String(s||'').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''); }
  /* colori noti (IT/EN): usati quando la variante non ha né swatch né immagine */
  var COLOR_HEX = {
    'bianco':'#f4f4f2','white':'#f4f4f2',
    'nero':'#141414','black':'#141414',
    'giallo':'#f6c026','yellow':'#f6c026',
    'rosso':'#e5241d','red':'#e5241d',
    'rosso-scuro':'#7c1418','dark-red':'#7c1418',
    'arancione':'#f07d1a','orange':'#f07d1a','pastel-orange':'#f07d1a',
    'viola':'#4a2a52','violet':'#4a2a52','purple':'#4a2a52',
    'rosa':'#d92f8c','pink':'#d92f8c',
    'blu':'#1e3a6b','blue':'#1e3a6b',
    'blu-navy':'#16233f','navy':'#16233f',
    'azzurro':'#0f9ed1','light-blue':'#0f9ed1',
    'verde-scuro':'#0c4a34','dark-green':'#0c4a34',
    'verde':'#1f8a2e','green':'#1f8a2e',
    'marrone':'#5a3423','brown':'#5a3423',
    'grigio':'#8a8a8a','grey':'#8a8a8a','gray':'#8a8a8a',
    'grigio-argento':'#c9ccce','silver-grey':'#c9ccce','silver':'#c9ccce',
    'argento':'#9a9ea3',
    'oro':'#c9a227','gold':'#c9a227'
  };
  var COLOR_METAL = { 'oro':1,'gold':1,'argento':1,'silver':1,'silver-grey':1,'grigio-argento':1 };
  const VINYL_COLORS = (function(){
    var src = window.WOW_VINYL_COLORS;
    if(!Array.isArray(src) || !src.length) return VINYL_FALLBACK;
    return src.map(function(c){
      var name = c.name || c.title || c.value || '';
      var slug = slugColor(name);
      var fb = VINYL_FALLBACK.filter(function(f){ return f.id === slug; })[0];
      var metal = c.metal != null ? !!c.metal : (!!COLOR_METAL[slug] || !!(fb && fb.metal));
      var hex = c.hex || (fb && fb.hex) || COLOR_HEX[slug] || '#c8c8c8';
      return {
        id: c.id || slug,
        name: name,
        img: c.img || c.image || null,
        hex: hex,
        hex2: c.hex2 || (fb && fb.hex2) || (metal ? '#f2f2f0' : null),
        metal: metal
      };
    }).filter(function(c){ return c.name; });
  })();
  function vinylById(id){ for(var i=0;i<VINYL_COLORS.length;i++){ if(VINYL_COLORS[i].id===id) return VINYL_COLORS[i]; } return VINYL_COLORS[0]; }
  function setVinylColor(id){
    var c=vinylById(id);
    state.colore=c.id; state.coloreName=c.name; state.vinylColor={hex:c.hex, metal:!!c.metal, hex2:c.hex2, img:c.img||null};
  }
  if(state.tipo==='prespaziato') setVinylColor(vinylById('nero').id);

  /* Form prodotto Shopify reale (tema): i campi properties[...] nascosti vengono
     tenuti allineati alla configurazione, così le proprietà arrivano intatte nel
     carrello e nell'ordine. Nel prototipo HTML il form non esiste. */
  const productForm = cfg.querySelector('#cfg-product-form');
  function setProductFormProp(name, value){
    if(!productForm) return;
    var fields = productForm.querySelectorAll('[data-prop-field]');
    for(var i = 0; i < fields.length; i++){
      if(fields[i].getAttribute('data-prop-field') === name){ fields[i].value = value || ''; return; }
    }
  }
  function syncProductFormProps(baseProps, fileUrl){
    if(!productForm) return;
    var props = baseProps || buildLineItemProps();
    Object.keys(props).forEach(function(k){ setProductFormProp(k, props[k]); });
    setProductFormProp('Colore', (state.tipo === 'prespaziato' && state.coloreName) ? state.coloreName : '');
    setProductFormProp('File', fileUrl || '');
    setProductFormProp('_file_originali', fileUrl || '');
  }
  function extractFormProperties(){
    var props = {};
    if(!productForm || !window.FormData) return props;
    new FormData(productForm).forEach(function(value, key){
      var m = /^properties\[(.+)\]$/.exec(key);
      if(m && typeof value === 'string'){ var v = value.trim(); if(v) props[m[1]] = v; }
    });
    return props;
  }
  /* Upload Lift inserisce nel form le proprie properties. Le togliamo dalla
     copia grezza e le ricostruiamo più sotto con una numerazione stabile:
     File_1 ↔ Anteprima_1, File_2 ↔ Anteprima_2, ecc. */
  function cleanOrderFileProperties(props){
    var out = {};
    Object.keys(props || {}).forEach(function(k){
      var isFileKey = /^File(?:_\d+)?$/i.test(k) || /^Anteprima(?:_\d+)?$/i.test(k) || k === 'File grafica' || /^_?(file|upload|cl-upload|anteprima)/i.test(k);
      if(!isFileKey) out[k] = props[k];
    });
    return out;
  }
  function originalUrlsInProps(props){
    var urls = [];
    Object.keys(props || {}).forEach(function(k){
      if(/^File(?:_\d+)?$/i.test(k) || k === 'File grafica' || /^_?(file|upload|cl-upload)/i.test(k)) collectULUrls(props[k], urls);
    });
    return uniq(urls.map(normalizeULUrl));
  }

  const steps = Array.from(cfg.querySelectorAll('.step-panel'));
  const pips  = Array.from(cfg.querySelectorAll('.step-pip'));
  let cur = 0;

  /* ---------- required-step validation ---------- */
  // ogni step è obbligatorio: se manca la scelta mostriamo un avviso che guida il cliente.
  var stepAlertEl = document.createElement('div');
  stepAlertEl.className = 'step-alert';
  stepAlertEl.setAttribute('role', 'alert');
  stepAlertEl.hidden = true;
  stepAlertEl.innerHTML = '<span class="msr">error</span><span class="step-alert-txt"></span>';
  function clearStepAlert(){ stepAlertEl.hidden = true; }
  function stepValid(i){
    var panel = steps[i];
    if(!panel) return { ok:true };
    var req = panel.getAttribute('data-req');
    if(req==='taglio' && !state.taglio) return { ok:false, msg:'Scegli un taglio per continuare.' };
    if(req==='size'){
      if(!state.size) return { ok:false, msg:'Seleziona una dimensione per continuare.' }; if(presTooSmall()) return { ok:false, msg:'Per gli sticker prespaziati la misura minima è 7×7 cm (49 cm²). Per formati più piccoli contattaci per un preventivo.' };
      if(state.size==='custom' && !(state.customW>0 && state.customH>0))
        return { ok:false, msg:'Inserisci larghezza e altezza (in cm) per il formato su misura.' };
    }
    if(req==='qty' && !state.qty) return { ok:false, msg:'Scegli la quantità per continuare.' };
    // ultimo step con caricamento file: la grafica è obbligatoria per ordinare
    if(!req && (panel.querySelector('.upload-zone') || panel.querySelector('[data-uploadlift-slot], [data-upload-shell]'))){
      if(state.uploading) return { ok:false, msg:'Attendi il completamento del caricamento del file.' };
      if(!state.fileUrl && !state.file) return { ok:false, msg:'Carica la tua grafica per completare l\u2019ordine.' };
      if(isMulti() && !state.subjects.length) return { ok:false, msg:'Carica almeno una grafica per continuare.' };
      // con Upload Lift reale il file conta solo quando l'app restituisce l'URL definitivo
      if(hasUploadLift() && !state.fileUrl)
        return { ok:false, msg:'Il caricamento del file non risulta completato. Riprova a caricarlo prima di ordinare.' };
    }
    return { ok:true };
  }
  function showStepAlert(msg){
    var t = stepAlertEl.querySelector('.step-alert-txt'); if(t) t.textContent = msg;
    var panel = steps[cur];
    if(panel){
      var sub = panel.querySelector('.step-sub');
      if(sub && sub.parentNode===panel){ sub.insertAdjacentElement('afterend', stepAlertEl); }
      else { panel.insertBefore(stepAlertEl, panel.firstChild); }
    }
    stepAlertEl.hidden = false;
    stepAlertEl.classList.remove('shake'); void stepAlertEl.offsetWidth; stepAlertEl.classList.add('shake');
    try{
      var r = stepAlertEl.getBoundingClientRect();
      if(r.bottom > window.innerHeight - 20 || r.top < 90){ window.scrollTo({ top: window.scrollY + r.top - 130, behavior:'smooth' }); }
    }catch(e){}
  }

  /* ---------- orientation helpers ---------- */
  // parse a standard size value "7x5" → [7,5]; null for custom / non-standard
  function sizeSides(val){
    if(typeof val==='string' && val.indexOf('x')>0){ var p=val.split('x'); var a=+p[0], b=+p[1]; if(a>0&&b>0) return [a,b]; }
    return null;
  }
  // a size supports an orientation choice only when it is rectangular (sides differ)
  function isRectSize(val){ var s=sizeSides(val); return !!(s && s[0]!==s[1]); }
  // dimension label reflecting the chosen orientation, e.g. "5×7 cm"
  function orientedSizeLabel(){
    if(state.size==='custom'){
      return (state.customW>0 && state.customH>0) ? ('Su misura · '+trimNum(state.customW)+'×'+trimNum(state.customH)+' cm') : 'Su misura';
    }
    var s = sizeSides(state.size);
    if(!s) return state.sizeLabel;
    var a=s[0], b=s[1];
    if(state.orientamento==='portrait' && a!==b){ var t=a; a=b; b=t; }
    return a+'×'+b+' cm';
  }
  function orientWord(){ return state.orientamento==='portrait' ? 'verticale' : 'orizzontale'; }
  // physical short side (cm) and the adaptive white-border thickness (2 mm ≤5cm, else 3 mm)
  function physShortCm(){
    if(state.size==='custom'){ var w=state.customW, h=state.customH; return (w>0&&h>0)?Math.min(w,h):null; }
    var s = sizeSides(state.size); return s ? Math.min(s[0],s[1]) : null;
  }
  function borderMMval(){ var sc=physShortCm(); return (sc!=null && sc<=5) ? 2 : 3; }

  // refresh the orientation selector: visibility, option labels, active state
  function updateOrientUI(){
    var sel = cfg.querySelector('#orient-select');
    if(!sel){ updateSagomatoInfo(); return; }
    // orientation applies to geometric cuts (rect/circle) and to the DTF transfer sheet —
    // for Sagomato/Kiss-cut the shape follows the subject, so it's hidden.
    var geo = (cutMode()==='rect' || cutMode()==='rounded' || cutMode()==='circle' || cutMode()==='dtf');
    var rect = isRectSize(state.size) && geo;
    sel.hidden = !rect;
    if(rect){
      var s = sizeSides(state.size), a=s[0], b=s[1];
      var land = cfg.querySelector('#orient-d-land'), port = cfg.querySelector('#orient-d-port');
      if(land) land.textContent = a+'×'+b+' cm';
      if(port) port.textContent = b+'×'+a+' cm';
      // proportional preview shapes (real aspect ratio of the format)
      var max = Math.max(a,b), base = 46;
      var shL = cfg.querySelector('#orient-shape-land'), shP = cfg.querySelector('#orient-shape-port');
      if(shL){ shL.style.width = Math.round(base*a/max)+'px'; shL.style.height = Math.round(base*b/max)+'px'; }
      if(shP){ shP.style.width = Math.round(base*b/max)+'px'; shP.style.height = Math.round(base*a/max)+'px'; }
      cfg.querySelectorAll('.orient-opt').forEach(function(o){
        o.classList.toggle('sel', o.dataset.orient===state.orientamento);
      });
    }
    updateSagomatoInfo();
  }

  // Sagomato note: the die-cut follows the subject, so instead of orientation we remind the
  // customer how the file is scaled — the longest side of the artwork is fitted to the chosen
  // measure and the other side develops proportionally.
  function updateSagomatoInfo(){
    var box = cfg.querySelector('#sagomato-info');
    if(!box) return;
    var cm = cutMode();
    // tutti i tagli che seguono il profilo della grafica: sagomato, Stampa-Taglio, prespaziato
    var profileCut = (cm==='contour' || cm==='stampataglio' || cm==='vinyl');
    var show = profileCut && !!state.size;
    box.hidden = !show;
    if(!show) return;
    var N, M;
    if(state.size==='custom'){
      if(!(state.customW>0 && state.customH>0)){ box.hidden = true; return; }
      N = Math.min(state.customW, state.customH); M = Math.max(state.customW, state.customH);
    } else {
      var s = sizeSides(state.size);
      if(!s){ box.hidden = true; return; }
      N = Math.min(s[0], s[1]); M = Math.max(s[0], s[1]);   // lato lungo entro il lato corto del formato; M = misura piu larga del formato
    }
    var lead = cm==='stampataglio' ? 'Stampa-Taglio: la lama segue il profilo di ogni elemento della grafica.'
             : cm==='vinyl' ? 'Prespaziato: l\u2019intaglio segue la sagoma della tua grafica.'
             : 'Taglio sagomato: la forma segue la tua grafica.';
    var txt = lead + ' Il <b>lato più lungo</b> del tuo file viene portato a <b>'+N+'&nbsp;cm</b> (non supera mai il formato scelto) e l\u2019altro lato si sviluppa in proporzione, <b>fino a un massimo di '+M+'&nbsp;cm</b>.';
    // if a file is loaded, show the concrete resulting size
    if(window.WowPreview && window.WowPreview.imageAspect){
      var asp = window.WowPreview.imageAspect();
      if(asp){
        var longAR = Math.max(asp, 1/asp);           // long ÷ short of the artwork
        var shortCm = N / longAR;                     // long side = N, other side in proportion
        var r = function(n){ return String(Math.round(n*10)/10).replace('.', ','); };
        txt += ' La tua grafica diventerà circa <b>'+r(N)+' × '+r(shortCm)+' cm</b>.';
      }
    }
    box.querySelector('.cut-note-txt').innerHTML = txt;
  }

  // adapt orientation to the uploaded graphic — unless the user already chose manually
  function maybeAutoOrient(){
    var hint = cfg.querySelector('#orient-hint');
    if(state.orientTouched || !isRectSize(state.size) || !(window.WowPreview && window.WowPreview.imageAspect)){
      if(hint) hint.hidden = true;
      return;
    }
    var asp = window.WowPreview.imageAspect();
    if(!asp){ if(hint) hint.hidden = true; return; }
    var want = null;
    if(asp < 0.85 && state.orientamento!=='portrait') want='portrait';
    else if(asp > 1.18 && state.orientamento!=='landscape') want='landscape';
    if(!want){ if(hint) hint.hidden = true; return; }
    state.orientamento = want;
    updateOrientUI(); render(); updatePreview();
    if(hint){
      var word = want==='portrait' ? 'verticale' : 'orizzontale';
      var lbl = orientedSizeLabel();
      hint.querySelector('.oh-txt').textContent = 'Ho girato il formato in '+word+' ('+lbl+') per adattarlo alla tua grafica —';
      hint.hidden = false;
    }
  }

  function showStep(i){
    cur = Math.max(0, Math.min(steps.length-1, i));
    clearStepAlert();
    steps.forEach((s,idx)=>s.classList.toggle('active', idx===cur));
    pips.forEach((p,idx)=>{
      p.classList.toggle('active', idx===cur);
      p.classList.toggle('done', idx<cur);
    });
    const back = cfg.querySelector('.link-back');
    if(back) back.disabled = cur===0;
    updateNextLabel();
  }

  function updateNextLabel(){
    const next = cfg.querySelector('.step-nav .btn-next');
    if(next){
      if(cur === steps.length-1){ next.innerHTML = 'Ordina ora <span class="ic">›</span>'; }
      else { next.innerHTML = 'Continua <span class="ic">›</span>'; }
    }
    const mb = document.getElementById('msum-btn');
    if(mb) mb.innerHTML = (cur === steps.length-1 ? 'Ordina ora ' : 'Continua ') + '<span class="ic">›</span>';
  }

  // option selection
  cfg.querySelectorAll('.opt').forEach(opt=>{
    opt.addEventListener('click', ()=>{
      const group = opt.dataset.group;
      cfg.querySelectorAll('.opt[data-group="'+group+'"]').forEach(o=>o.classList.remove('sel'));
      opt.classList.add('sel');
      clearStepAlert();
      const val = opt.dataset.value;
      const label = opt.dataset.label || opt.querySelector('.opt-t').textContent;
      if(group==='tipo'){ state.tipo=val; state.tipoLabel=label; }
      if(group==='taglio'){ state.taglio=val; state.taglioLabel=label; updateOrientUI(); }
      if(group==='size'){
        state.size=val; state.sizeLabel=label; toggleCustomSize(val==='custom');
        // new size = fresh orientation decision; auto-orient may re-adapt to the file
        state.orientamento='landscape'; state.orientTouched=false;
        updateOrientUI();
        if(window.WowPreview && window.WowPreview.hasImage && window.WowPreview.hasImage()) maybeAutoOrient();
      }
      if(group==='qty'){ state.qty=parseInt(val,10); }
      if(group==='soggetti'){ setSoggetti(val === 'multi' ? 'multi' : 1); }
      render();
      updatePreview();
      refreshSubjects();
    });
  });

  // ---- custom size (priced per m²) ----
  function toggleCustomSize(on){
    const box = cfg.querySelector('#size-custom');
    if(box) box.hidden = !on;
  }
  ['cw','ch'].forEach(id=>{
    const el = cfg.querySelector('#'+id);
    if(!el) return;
    el.addEventListener('input', ()=>{
      const cw = cfg.querySelector('#cw'), ch = cfg.querySelector('#ch');
      state.customW = parseFloat(cw && cw.value) || null;
      state.customH = parseFloat(ch && ch.value) || null;
      if(state.customW>0 && state.customH>0) clearStepAlert();
      render(); updatePreview();
    });
  });

  // ---- orientation selector (manual choice locks out auto-orient) ----
  cfg.querySelectorAll('.orient-opt').forEach(function(btn){
    btn.addEventListener('click', function(){
      var o = btn.dataset.orient;
      if(!o || o===state.orientamento){ state.orientTouched=true; return; }
      state.orientamento = o;
      state.orientTouched = true;
      var hint = cfg.querySelector('#orient-hint'); if(hint) hint.hidden = true;
      updateOrientUI(); render(); updatePreview();
    });
  });
  // ---- undo the auto-orient flip (also counts as a manual choice) ----
  var ohUndo = cfg.querySelector('.oh-undo');
  if(ohUndo) ohUndo.addEventListener('click', function(){
    state.orientamento = state.orientamento==='portrait' ? 'landscape' : 'portrait';
    state.orientTouched = true;
    var hint = cfg.querySelector('#orient-hint'); if(hint) hint.hidden = true;
    updateOrientUI(); render(); updatePreview();
  });

  // ---- LIVE PREVIEW wiring ----
  const stage = cfg.querySelector('.preview-stage');

  // Context background of the preview — a CSS layer only. It is NEVER drawn into the canvas,
  // so getCutoutDataURL() and the order attachment stay on real transparency.
  let bgContext = 'checker', bgTouched = false, lastBgTipo = null;
  const bgSwatches = cfg.querySelector('#bg-swatches');
  const bgRow = bgSwatches ? bgSwatches.querySelector('.bgsw-row') : null;
  // context-background sets per material (DTF sees fabric surfaces to preview the transfer on a garment)
  const BG_SETS = {
    trasparente: [['vetro','Vetro'],['light','Superficie chiara'],['dark','Superficie scura'],['checker','Scacchiera']],
    dtf:         [['fabric-dark','Tessuto scuro'],['fabric-light','Tessuto chiaro'],['neutral','Superficie neutra']],
    prespaziato: [['vetro','Vetrina'],['light','Muro chiaro'],['dark','Carrozzeria scura']],
    stampataglio:[['vetrina','Vetrina bokeh'],['light','Superficie chiara'],['dark','Superficie scura'],['checker','Scacchiera']],
    _default:    [['light','Superficie chiara'],['dark','Superficie scura'],['checker','Scacchiera'],['vetro','Vetro']]
  };
  function bgSetFor(tipo){ return BG_SETS[tipo] || BG_SETS._default; }
  function defaultBgFor(tipo){ return tipo==='stampataglio' ? 'vetrina' : (tipo==='trasparente'||tipo==='prespaziato') ? 'vetro' : (tipo==='dtf' ? 'fabric-dark' : 'light'); }
  function renderSwatches(tipo){
    if(!bgRow) return;
    bgRow.innerHTML = bgSetFor(tipo).map(function(o){ return '<button type="button" class="bgsw" data-bg="'+o[0]+'" title="'+o[1]+'" aria-label="'+o[1]+'"></button>'; }).join('');
    bgRow.querySelectorAll('.bgsw').forEach(function(sw){ sw.addEventListener('click', function(){ bgTouched=true; applyContextBg(sw.dataset.bg); }); });
  }
  function applyContextBg(bg){
    bgContext = bg;
    if(stage) stage.setAttribute('data-bg', bg);
    // NB: la mini anteprima del riepilogo resta sempre a sfondo bianco (non segue lo swatch)
    cfg.querySelectorAll('.bgsw').forEach(s=> s.classList.toggle('sel', s.dataset.bg===bg));
  }
  function syncContextBg(has){
    if(bgSwatches) bgSwatches.hidden = !has;
    if(state.tipo !== lastBgTipo){ lastBgTipo = state.tipo; bgTouched = false; renderSwatches(state.tipo); }  // new material → its set + default
    applyContextBg(bgTouched ? bgContext : defaultBgFor(state.tipo));
  }

  const chipsBox = cfg.querySelector('#effect-chips');
  ['#preview-main','#preview-mini'].forEach(sel=>{ const c=cfg.querySelector(sel); if(c && window.WowPreview) window.WowPreview.register(c); });

  const EFFECT = { trasparente:['layers_clear','Sfondo trasparente'], olografico:['blur_on','Riflessi olografici'], oro:['auto_awesome','Finitura oro'], magnetico:['hardware','Supporto magnetico'], dtf:['iron','Applicazione a caldo'], prespaziato:['content_cut','Lettering intagliato'], bifacciale:['flip','Stampa fronte/retro'] };
  const CUTMAP = { sagomato:'contour', quadrato:'rect', angoli:'rounded', tondo:'circle', foglio:'sheet', dtf:'dtf', vinyl:'vinyl' };
  function cutMode(){
    if(state.tipo==='dtf') return 'dtf';
    if(state.tipo==='prespaziato') return 'vinyl';
    if(state.tipo==='stampataglio') return 'stampataglio';
    if(state.taglio) return CUTMAP[state.taglio] || 'contour';
    return state.tipo==='sagomato' ? 'contour' : 'rect';   // generic configurator fallback
  }
  function isContourCut(){
    return state.taglio==='sagomato' || (!state.taglio && state.tipo==='sagomato') || state.taglio==='foglio';
  }
  function manualAdaptState(){
    return !!(window.WowPreview && window.WowPreview.hasImage() && window.WowPreview.isFallback && window.WowPreview.isFallback() && (cutMode()==='contour' || cutMode()==='sheet' || cutMode()==='vinyl' || cutMode()==='stampataglio'));
  }
  // Prespaziati cut-suitability notes (multicolour / small detail / photo)
  function updateVinylNotes(has, isVinyl){
    var box = cfg.querySelector('#vinyl-notes'); if(!box) return;
    if(!isVinyl || !has){ box.hidden = true; box.innerHTML=''; return; }
    var P = window.WowPreview, msgs = [];
    if(P.isFallback && P.isFallback()){
      msgs.push(['warn','content_cut','Il prespaziato richiede grafiche a tratti netti (loghi, scritte). Per foto o immagini complesse usa la <a href="#">Stampa e taglio →</a>. Se procedi, i nostri grafici valutano il file (controllo incluso).']);
    } else {
      if(P.subjectColorCount && P.subjectColorCount()>1)
        msgs.push(['info','palette','I prespaziati sono in un solo colore: ecco l\u2019anteprima nel colore scelto. Per il multicolore c\u2019\u00e8 la <a href="#">Stampa e taglio →</a>.']);
      var s = sizeSides(state.size);
      var physLong = state.size==='custom' ? Math.max(state.customW||0, state.customH||0) : (s?Math.max(s[0],s[1]):7);
      if(P.minDetailMm){ var md=P.minDetailMm(physLong); if(md<2)
        msgs.push(['warn','warning','Alcuni dettagli sono molto piccoli per l\u2019intaglio: potremmo proporti di semplificarli o aumentare la dimensione. Lo verifichiamo noi con il controllo file incluso.']); }
    }
    box.hidden = msgs.length===0;
    box.innerHTML = msgs.map(function(m){ return '<p class="preview-note'+(m[0]==='warn'?' warn':'')+'"><span class="msr">'+m[1]+'</span> <span>'+m[2]+'</span></p>'; }).join('');
  }
  function setupVinylSwatches(){
    var grid = cfg.querySelector('#vinyl-swatches'); if(!grid) return;
    grid.innerHTML = VINYL_COLORS.map(function(c){
      var sw = c.metal ? ('linear-gradient(135deg,'+(c.hex2||'#fff')+','+c.hex+' 55%,'+(c.hex2||'#fff')+')') : c.hex;
      var dot = c.img
        ? '<span class="vsw-dot has-img" style="background-image:url('+c.img+')"></span>'
        : '<span class="vsw-dot" style="background:'+sw+'"></span>';
      return '<button type="button" class="vsw'+(c.id===state.colore?' sel':'')+'" data-color="'+c.id+'" title="'+c.name+'">'+dot+'<span class="vsw-name">'+c.name+'</span></button>';
    }).join('');
    grid.querySelectorAll('.vsw').forEach(function(b){ b.addEventListener('click', function(){
      setVinylColor(b.dataset.color);
      grid.querySelectorAll('.vsw').forEach(function(x){ x.classList.toggle('sel', x.dataset.color===state.colore); });
      render(); updatePreview();
    }); });
  }
  function effectChips(){
    if(!chipsBox) return;
    if(!window.WowPreview || !window.WowPreview.hasImage()){ chipsBox.innerHTML='<span class="echip muted">Carica un file per vedere la magia</span>'; return; }
    const chips=[];
    if(manualAdaptState()){
      chips.push(['','✂️ Adattamento manuale incluso']);
    } else if(state.tipo==='stampataglio'){
      chips.push(['content_cut','Taglio aderente al profilo']);
      if(state.vinylTape) chips.push(['dashboard_customize','Pellicola di trasporto']);
    } else if(state.tipo==='mezzotaglio'){
      chips.push(['approval','Mezzo taglio (kiss-cut)']);
      if(cutMode()==='contour'){
        var km = (window.WowPreview && window.WowPreview.kissBorderMode) ? window.WowPreview.kissBorderMode() : null;
        chips.push(km==='flat' ? ['gradient','Sfondo pieno fino al taglio'] : ['border_style','Bordo bianco']);
      } else {
        chips.push(['note_add','Bleed 2 mm']);
      }
    } else {
      const cut = state.taglio || (state.tipo==='sagomato'?'sagomato':'quadrato');
      const isTransp = (state.tipo==='trasparente');
      if(cut==='sagomato') chips.push(['border_style', isTransp?'Margine trasparente':'Bordo bianco die-cut']);
      else if(cut==='foglio') chips.push(['grid_view','Kiss-cut a foglio']);
      else if(cut==='tondo') chips.push(['circle','Taglio tondo']);
      else if(cut==='angoli') chips.push(['rounded_corner','Angoli arrotondati']);
      else chips.push(['crop_square','Taglio squadrato']);
      if((cutMode()==='rect' || cutMode()==='rounded' || cutMode()==='circle') && state.bordoBianco && !isTransp) chips.push(['border_style','Bordo bianco']);
    }
    const e = EFFECT[state.tipo]; if(e) chips.push(e);
    chipsBox.innerHTML = chips.map(c=>'<span class="echip">'+(c[0]?'<span class="msr ic">'+c[0]+'</span>':'')+c[1]+'</span>').join('');
  }

  function updatePreview(){
    if(!window.WowPreview) return;
    const has = window.WowPreview.hasImage();
    const adapt = manualAdaptState();
    if(stage){ stage.classList.toggle('has-image', has); stage.classList.toggle('adapt', adapt); }
    const sumvis = cfg.querySelector('#sum-vis'); if(sumvis){ sumvis.classList.toggle('has-image', has); sumvis.classList.toggle('adapt', adapt); }
    // discrete physical-size reference on the preview (the shape no longer conveys real scale)
    const szBadge = cfg.querySelector('#preview-size-badge');
    if(szBadge){
      const ok = has && state.size && !(state.size==='custom' && !(state.customW>0 && state.customH>0));
      szBadge.hidden = !ok;
      if(ok) szBadge.textContent = orientedSizeLabel().replace(/^Su misura · /,'');
    }
    if(has) window.WowPreview.update({ tipo:state.tipo, shapeMode:cutMode(), finitura:'standard', size:state.size, customW:state.customW, customH:state.customH, orientamento:state.orientamento, bordoBianco:state.bordoBianco, sfondoIncluso:state.sfondoIncluso, dtfRemoveBg:state.dtfRemoveBg, geoRemoveBg:state.geoRemoveBg, vinylColor:state.vinylColor, vinylTape:state.vinylTape });
    const bt = cfg.querySelector('#border-toggle');
    const isTransp = (state.tipo==='trasparente');
    const isOlo = (state.tipo==='olografico');
    const isOro = (state.tipo==='oro');
    const isDtf = (state.tipo==='dtf');
    const isVinyl = (state.tipo==='prespaziato');
    const isStampa = (state.tipo==='stampataglio');
    const isMezzo = (state.tipo==='mezzotaglio');
    const geoCut = (cutMode()==='rect' || cutMode()==='rounded' || cutMode()==='circle');
    // white/holo/gold-border toggle: geometric cuts only, mai su trasparente né su Mezzo Taglio (il bleed non è un bordo estetico)
    if(bt) bt.hidden = !(geoCut && !isTransp && !isMezzo);
    const btLabel = cfg.querySelector('#border-toggle .bt-label');
    if(btLabel) btLabel.innerHTML = (isOlo ? 'Bordo holo' : isOro ? 'Bordo oro' : 'Bordo bianco')
      + ' <small>· +'+borderMMval()+' mm '+((isOlo||isOro) ? 'foil metallizzato' : 'attorno alla grafica')+'</small>';
    // transparent material: chip replaces the white-border toggle on geometric cuts
    const tchip = cfg.querySelector('#transp-chip');
    if(tchip) tchip.hidden = !(geoCut && isTransp);
    const bgt = cfg.querySelector('#bg-toggle');
    // "Includi lo sfondo" only matters for die-cut / kiss-cut (shape follows the subject).
    // For quadrato/tondo the whole graphic — background included — always fills the shape.
    const bgRelevant = (cutMode()==='contour' || cutMode()==='sheet');
    if(bgt) bgt.hidden = !(bgRelevant && window.WowPreview.hasBackgroundPlate && window.WowPreview.hasBackgroundPlate());
    // DTF: optional "remove background from print" (only when the file has a removable uniform bg)
    const dtfbt = cfg.querySelector('#dtf-bg-toggle');
    if(dtfbt) dtfbt.hidden = !(isDtf && has && window.WowPreview.hasRemovableBg && window.WowPreview.hasRemovableBg());
    const dnote = cfg.querySelector('#dtf-note');
    if(dnote) dnote.hidden = !(isDtf && has);
    const onote = cfg.querySelector('#oro-note');
    if(onote) onote.hidden = !(isOro && has);
    const mnote = cfg.querySelector('#mezzo-note');
    if(mnote) mnote.hidden = !(isMezzo && has);
    const mbnote = cfg.querySelector('#mezzo-bleed-note');
    if(mbnote) mbnote.hidden = !(isMezzo && has);
    // Geometric cut + colored/dark uniform bg → offer "remove background" (OFF default; bg is part of design)
    const geobt = cfg.querySelector('#geo-bg-toggle');
    const coloredBg = has && window.WowPreview.hasColoredBg && window.WowPreview.hasColoredBg();
    if(geobt){
      geobt.hidden = !(geoCut && coloredBg);
      const gl = geobt.querySelector('.bt-label');
      if(gl) gl.innerHTML = 'Rimuovi lo sfondo <small>· lo sfondo colorato fa parte della grafica</small>';
    }
    // Prespaziati: application-tape toggle + cut-suitability notes
    const vtape = cfg.querySelector('#vinyl-tape-toggle');
    if(vtape) vtape.hidden = !((isVinyl||isStampa) && has);
    updateVinylNotes(has, isVinyl);
    // context-background swatches + transparent honest-colour note
    syncContextBg(has, isTransp);
    const tnote = cfg.querySelector('#transp-note');
    if(tnote){
      tnote.hidden = !(isTransp && has);
      const lr = (window.WowPreview.lightGraphicRatio && window.WowPreview.lightGraphicRatio()) || 0;
      tnote.classList.toggle('warn', isTransp && has && lr > 0.6);
    }
    const pm = cfg.querySelector('#preview-main');
    if(pm){ pm.setAttribute('aria-label', adapt ? 'Anteprima non disponibile: l’adattamento al taglio sagomato è a cura dei nostri grafici, incluso senza costi' : ('Anteprima del tuo sticker' + (state.taglioLabel?(' '+state.taglioLabel.toLowerCase()):'') + (state.sizeLabel?(' '+state.sizeLabel):''))); }
    const note = cfg.querySelector('#preview-note'); if(note) note.hidden = true;   // replaced by the adapt card
    effectChips();
  }

  function loadIntoPreview(src, name){
    if(!window.WowPreview) return;
    addSubject(src, name);
    if(chipsBox) chipsBox.innerHTML='<span class="echip"><span class="msr ic">content_cut</span> ✂️ Preparo il tuo sticker…</span>';
    window.WowPreview.setImage(src).then(()=>{
      state.file = true;
      clearStepAlert();
      // default: include the dark/colored background (part of the design) — but NOT for
      // Trasparente, where the die-cut margin must stay clear film unless the user opts in.
      if(window.WowPreview.hasBackgroundPlate){
        state.sfondoIncluso = (state.tipo!=='trasparente') && window.WowPreview.hasBackgroundPlate();
        const sf=cfg.querySelector('#cfg-sfondo'); if(sf) sf.checked = !!state.sfondoIncluso;
      }
      const z = cfg.querySelector('.upload-zone');
      markZoneLoaded(z, name || 'Esempio caricato');
      render(); updatePreview();
      maybeAutoOrient();
      updateOrientUI();
    }).catch(()=>{});
  }

  // upload
  /* Caricamento file: nel tema reale l'upload passa da Upload Lift e restituisce
     l'URL finale. Finché l'upload non è al 100% i pulsanti Continua / Ordina ora
     restano bloccati; il polling di sicurezza sblocca appena arriva l'URL. */
  var upStatus = cfg.querySelector('#up-status');
  var upsName = cfg.querySelector('#ups-name');
  var upsPct  = cfg.querySelector('#ups-pct');
  var upsFill = cfg.querySelector('#ups-fill');
  var upsMsg  = cfg.querySelector('#ups-msg');
  var upDim   = cfg.querySelector('#up-dim');
  var upWrap  = cfg.querySelector('.upload-wrap');
  var upCol   = cfg.querySelector('.upload-col');
  var upTimer = null;
  function setNextDisabled(on, reason){
    cfg.querySelectorAll('.btn-next').forEach(function(b){
      if(on){
        b.setAttribute('disabled','');
        if(reason === 'upload'){
          if(!b.getAttribute('data-upload-label')) b.setAttribute('data-upload-label', b.innerHTML);
          b.classList.add('is-upload-wait');
          b.innerHTML = '<span class="ups-spin" aria-hidden="true"></span> Attendi il caricamento…';
        }
      } else {
        b.removeAttribute('disabled');
        var label = b.getAttribute('data-upload-label');
        if(label){ b.innerHTML = label; b.removeAttribute('data-upload-label'); }
        b.classList.remove('is-upload-wait');
      }
    });
  }
  function paintUpload(pct){
    if(upsPct) upsPct.textContent = Math.round(pct) + '%';
    if(upsFill) upsFill.style.width = pct + '%';
    if(isMulti() && state.uploading) setMultiBar('loading', pct);
  }
  function beginUpload(f){
    if(!upStatus) return;
    clearInterval(upTimer);
    state.uploading = true;
    if(!isMulti()){
      state.fileUrl = '';
      state.fileUrls = [];
      state.originalFileUrls = [];
    }
    setNextDisabled(true, 'upload');
    upStatus.hidden = false;
    upStatus.classList.remove('is-done');
    if(isMulti()){
      // con più soggetti l'attesa è una barra sottile sotto il riquadro
      upStatus.hidden = true;
      if(upDim) upDim.hidden = true;
      setMultiBar('loading', null, (state.originalFileUrls || []).length, state.uploadTargetCount || 1);
    } else {
      // overlay centrato sopra upload + anteprima, con velo scuro
      if(upWrap && upStatus.parentNode !== upWrap) upWrap.appendChild(upStatus);
      upStatus.classList.add('is-overlay');
      if(upDim) upDim.hidden = false;
    }
    if(upsName) upsName.textContent = f.name;
    if(upsMsg) upsMsg.innerHTML = '<span class="msr">cloud_sync</span> <span>Caricamento in corso… non chiudere la pagina.</span>';
    if(hasUploadLift()){
      // upload reale: l'avanzamento lo governa Upload Lift, non simuliamo il 100%
      if(upStatus) upStatus.classList.add('is-indeterminate');
      paintUpload(0);
      if(upsPct) upsPct.textContent = '…';
      pollUploadLiftCompletion();
      return;
    }
    if(upStatus) upStatus.classList.remove('is-indeterminate');
    var pct = 0;
    paintUpload(0);
    upTimer = setInterval(function(){
      pct += pct < 70 ? 9 + Math.random()*8 : 3 + Math.random()*4;
      if(pct >= 100){
        pct = 100; paintUpload(100); clearInterval(upTimer);
        finishUpload(f);
      } else paintUpload(pct);
    }, 170);
  }
  function finishUpload(f){
    state.uploading = false;
    state.file = true;
    if(!state.fileUrl) state.fileUrl = 'https://cdn.uploadlift.app/wowsticker/' + Date.now().toString(36) + '/' + encodeURIComponent(f.name);
    if(upStatus){ upStatus.classList.remove('is-indeterminate'); }
    paintUpload(100);
    setNextDisabled(false);
    // a caricamento finito torna inline, sotto il blocco upload
    if(upDim) upDim.hidden = true;
    if(upStatus){
      upStatus.classList.remove('is-overlay');
      upStatus.classList.add('is-done');
      upStatus.hidden = isMulti();
      if(isMulti()) setMultiBar('done');
      var demo = upCol && upCol.querySelector('.btn-demo');
      if(upCol){ if(demo) upCol.insertBefore(upStatus, demo); else upCol.appendChild(upStatus); }
    }
    if(upsMsg) upsMsg.innerHTML = '<span class="msr">check_circle</span> <span>Caricamento completato · controllo file incluso.</span>';
    clearStepAlert();
    render();
  }
  /* ---------- Upload Lift reale (tema Shopify) ----------
     Il blocco upload del tema è l'app block Upload Lift (FilePond). Qui lo
     montiamo nello slot del configuratore, gli diamo la nostra veste grafica e
     leggiamo l'URL finale del file: da postMessage, dal DOM del widget o da
     localStorage['cl_files']. Nelle pagine HTML del prototipo lo slot non
     esiste e resta attivo l'input nativo con avanzamento simulato. */
  function hasUploadLift(){ return !!getULMount(); }
  function getULMount(){
    var mode = isMulti() ? 'multi' : '1';
    return cfg.querySelector('[data-uploadlift-slot][data-mode="' + mode + '"]')
        || cfg.querySelector('[data-uploadlift-slot]')
        || cfg.querySelector('.upload-lift-plus, [data-upload-lift], [data-uploadlift]');
  }
  function normalizeULUrl(value){
    if(typeof value !== 'string') return '';
    var url = value.trim().replace(/^"+|"+$/g,'').replace(/^'+|'+$/g,'');
    if(!url) return '';
    if(url.indexOf('//') === 0) url = 'https:' + url;
    return /https?:\/\/(?:upload\.)?cloudlift\.app\//i.test(url) ? url : '';
  }
  function collectULUrls(value, bucket){
    if(value == null) return;
    if(typeof value === 'string'){
      var direct = normalizeULUrl(value); if(direct) bucket.push(direct);
      (value.match(/https?:\/\/[^\s"'<>]+/g) || []).forEach(function(m){ var n = normalizeULUrl(m); if(n) bucket.push(n); });
      return;
    }
    if(Array.isArray(value)){ value.forEach(function(v){ collectULUrls(v, bucket); }); return; }
    if(typeof value === 'object') Object.keys(value).forEach(function(k){ collectULUrls(value[k], bucket); });
  }
  function uniq(list){ var seen = {}; return (list||[]).filter(function(v){ if(typeof v !== 'string') return false; var k = v.trim(); if(!k || seen[k]) return false; seen[k] = true; return true; }); }
  function ulFindName(value){
    if(!value || typeof value !== 'object') return '';
    for(var q = [value]; q.length;){
      var cur2 = q.shift(); if(!cur2 || typeof cur2 !== 'object') continue;
      if(Array.isArray(cur2)){ cur2.forEach(function(e){ q.push(e); }); continue; }
      var keys = Object.keys(cur2);
      for(var i = 0; i < keys.length; i++){
        var e = cur2[keys[i]];
        if(typeof e === 'string' && /^(name|fileName|filename|originalName|originalFilename)$/i.test(keys[i]) && !normalizeULUrl(e)) return e.trim();
        if(e && typeof e === 'object') q.push(e);
      }
    }
    return '';
  }
  function storeULUrls(urls, meta){
    var cleaned = uniq((urls||[]).map(normalizeULUrl));
    if(!cleaned.length) return false;
    // Durante la generazione delle anteprime lo stesso widget riceve altri
    // file: non devono mai finire nella lista degli originali del cliente.
    if(state.previewUploading) return false;
    var originals = isMulti() ? uniq((state.originalFileUrls || []).concat(cleaned)) : cleaned.slice(0,1);
    state.originalFileUrls = originals;
    state.fileUrl = originals[0] || '';
    state.fileUrls = originals.slice();
    if(isMulti()){
      var target = state.uploadTargetCount || state.subjects.length || 1;
      if(originals.length < target){
        state.uploading = true;
        state.file = true;
        setNextDisabled(true, 'upload');
        setMultiBar('loading', null, originals.length, target);
        return true;
      }
    }
    var name = (meta && meta.name) || state.fileName || '';
    if(!name){ try{ var parts = new URL(state.fileUrl).pathname.split('/'); name = parts[parts.length-1] || 'File caricato'; }catch(e){ name = 'File caricato'; } }
    state.fileName = name;
    if(upsName && !upsName.textContent) upsName.textContent = name;
    finishUpload({ name: name });
    return true;
  }
  function ulSyncSlots(){
    var slots = cfg.querySelectorAll('[data-uploadlift-slot][data-mode]');
    if(!slots.length) return;
    var mode = isMulti() ? 'multi' : '1';
    slots.forEach(function(s){ s.hidden = (s.getAttribute('data-mode') !== mode); });
  }
  function ulSkinAll(){ ulSyncSlots(); cfg.querySelectorAll('[data-uploadlift-slot]').forEach(function(s){ ulSkin(s); }); }
  function ulSkin(slot){
    slot = slot || getULMount(); if(!slot) return false;
    var container = slot.querySelector('.upload-container .cl-upload--wrapper') || slot.querySelector('.upload-container') || slot.querySelector('.cl-upload--wrapper') || slot.querySelector('.filepond--root.cl-upload--area') || slot.querySelector('.shopify-app-block');
    if(!container) return false;
    var root = (container.matches && container.matches('.filepond--root')) ? container : container.querySelector('.filepond--root');
    if(!root) return false;
    var host = slot.querySelector('.upload-lift-host');
    if(!host){ host = document.createElement('div'); host.className = 'upload-lift-host'; slot.appendChild(host); }
    if(container.parentElement !== host) host.appendChild(container);
    root.style.height = ''; root.style.minHeight = '';
    var label = root.querySelector('.filepond--drop-label label');
    if(label && !label.getAttribute('data-wow-skin')){
      label.setAttribute('data-wow-skin','true');
      label.innerHTML = '<span class="uplift-ui" aria-hidden="true"><span class="uplift-ui__icon"><span class="msr">cloud_upload</span></span><span class="uplift-ui__title">Trascina qui il tuo file</span><span class="uplift-ui__sub">oppure clicca per selezionarlo · max 100 MB</span><span class="uplift-ui__chips"><span class="chip"><span class="msr ic">picture_as_pdf</span> PDF</span><span class="chip"><span class="msr ic">image</span> JPG / PNG</span></span></span>';
    }
    // Il campo Upload Lift multiplo ha 10 slot tecnici: 5 originali + 5
    // anteprime generate. Il contatore tecnico non deve invitare il cliente a
    // caricare più delle 5 grafiche previste dal configuratore.
    var liftCounter = slot.querySelector('.cl-upload--counter');
    if(liftCounter && slot.getAttribute('data-mode') === 'multi') liftCounter.style.display = 'none';
    Array.prototype.slice.call(slot.children || []).forEach(function(child){
      if(child !== host && !child.contains(host) && child.tagName !== 'SCRIPT' && child.tagName !== 'STYLE') child.style.display = 'none';
    });
    return true;
  }
  function ulMount(){
    var slot = getULMount(); if(!slot) return false;
    if(slot.hasAttribute('data-mode')) ulSyncSlots(); else slot.hidden = false;
    // se l'app rende il widget fuori dal configuratore, lo riportiamo nello slot
    var stray = document.querySelector('.cl-upload--wrapper, .filepond--root.cl-upload--area');
    if(stray && !cfg.contains(stray)){ slot.appendChild(stray.closest('.upload-container') || stray); return ulSkin(slot); }
    if(slot.querySelector('.filepond--root, .cl-upload--wrapper')) return ulSkin();
    // prendiamo solo un contenitore che contenga davvero il widget: il
    // .upload-container vuoto dentro il form è il punto di innesto dell'app,
    // non il widget già renderizzato.
    var live = document.querySelector('.cl-upload--wrapper') || document.querySelector('.filepond--root.cl-upload--area');
    if(live && !slot.contains(live)){
      var box = live.closest('.upload-container') || live;
      slot.appendChild(box);
      return ulSkin();
    }
    return false;
  }
  function ulScanMount(){
    var mount = getULMount(); if(!mount) return false;
    var urls = [];
    mount.querySelectorAll('[href],[src],[value],[data-url],[data-file-url],[data-upload-url]').forEach(function(node){
      ['href','src','value','data-url','data-file-url','data-upload-url'].forEach(function(attr){
        var v = node.getAttribute && node.getAttribute(attr); if(v) collectULUrls(v, urls);
      });
      if(typeof node.value === 'string' && node.value) collectULUrls(node.value, urls);
    });
    collectULUrls(mount.textContent || '', urls);
    ulSkin();
    return storeULUrls(urls, {});
  }
  function readCookie(name){
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g,'\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function ulScanStorage(force){
    if(!state.uploading && !force) return false;
    try{
      if(!window.localStorage) return false;
      var raw = localStorage.getItem('cl_files'); if(!raw) return false;
      var parsed = JSON.parse(raw);
      if(!Array.isArray(parsed) || !parsed.length) return false;
      var token = readCookie('token');
      var pool = token ? parsed.filter(function(e){ return e && e.token === token; }) : parsed.slice();
      if(!pool.length) pool = parsed.slice();
      var latest = pool.slice().reverse();
      for(var i = 0; i < latest.length; i++){
        var urls = []; collectULUrls(latest[i], urls);
        if(storeULUrls(urls, { name: ulFindName(latest[i]) })) return true;
      }
    }catch(e){}
    return false;
  }
  function pollUploadLiftCompletion(){
    var attempts = 0;
    (function tick(){
      if(!state.uploading) return;
      attempts++;
      ulScanMount(); ulScanStorage();
      if(!state.uploading) return;
      if(attempts < 80) setTimeout(tick, 1500);
      else uploadStalled();
    })();
  }
  /* Upload Lift non ha restituito l'URL: liberiamo l'interfaccia invece di
     lasciare il cliente bloccato sotto il velo. */
  function uploadStalled(){
    state.uploading = false;
    if(upDim) upDim.hidden = true;
    if(upStatus){
      upStatus.classList.remove('is-overlay','is-indeterminate','is-done');
      upStatus.classList.add('is-error');
      var demo = upCol && upCol.querySelector('.btn-demo');
      if(upCol){ if(demo) upCol.insertBefore(upStatus, demo); else upCol.appendChild(upStatus); }
      if(upsPct) upsPct.textContent = '';
      if(upsFill) upsFill.style.width = '100%';
      if(upsMsg) upsMsg.innerHTML = '<span class="msr">error</span> <span>Non riusciamo a confermare il caricamento. Riprova a caricare il file, oppure <a href="https://wa.me/393889095421" target="_blank" rel="noopener">scrivici su WhatsApp</a>.</span> <button type="button" class="ups-retry" id="ups-retry">Riprova</button>';
      var retry = upStatus.querySelector('#ups-retry');
      if(retry) retry.addEventListener('click', function(){
        upStatus.classList.remove('is-error');
        upStatus.hidden = true;
        var inp = getULMount() && getULMount().querySelector('input[type="file"]');
        if(inp) inp.click(); else if(upInput) upInput.click();
      });
    }
    setNextDisabled(false);
    render();
  }
  function ulBindInput(){
    var mount = getULMount(); if(!mount) return false;
    var input = mount.querySelector('input[type="file"]'); if(!input) return false;
    if(input.getAttribute('data-wow-preview-bound') === 'true') return true;
    input.setAttribute('data-wow-preview-bound','true');
    input.addEventListener('change', function(){
      if(!isMulti() || state.previewUploading || !input.files || input.files.length <= (MAX_SUBJ - state.subjects.length)) return;
      var remaining = Math.max(0, MAX_SUBJ - state.subjects.length);
      if(window.DataTransfer){
        var limited = new DataTransfer();
        for(var j = 0; j < remaining; j++) limited.items.add(input.files[j]);
        input.files = limited.files;
      }
      showStepAlert('Puoi caricare al massimo ' + MAX_SUBJ + ' grafiche. Ho mantenuto solo i primi ' + remaining + ' file selezionati.');
    }, true);
    input.addEventListener('change', function(){
      var fl = input.files;
      // selezione multipla: ogni file è un soggetto, non un solo caricamento
      if(fl && fl.length){ state.fileName = fl[0].name; handleFiles(fl); }
      [1200, 3000, 6000].forEach(function(ms){ setTimeout(ulScanStorage, ms); });
    });
    return true;
  }
  (function bindUploadLift(){
    if(!cfg.querySelector('[data-uploadlift-slot]')) return;
    window.addEventListener('message', function(ev){
      if(ev.origin && !/cloudlift\.app/i.test(ev.origin)) return;
      var urls = []; collectULUrls(ev.data, urls);
      storeULUrls(urls, { name: ulFindName(ev.data) });
    });
    function sync(){ ulMount(); ulSkinAll(); ulBindInput(); ulScanMount(); }
    sync();
    [600, 1800, 3500].forEach(function(ms){ setTimeout(sync, ms); });
    // NON leggiamo cl_files all'avvio: un file di una sessione precedente
    // marcherebbe l'ordine come già caricato. Lo scansioniamo solo dopo che
    // il cliente ha scelto un file in questa pagina.
  })();

  /* ---------- soggetti multipli (max 5) ----------
     "Sticker in Foglio" ha una pagina dedicata e non usa questo blocco. */
  var MAX_SUBJ = 5;
  state.soggetti = 1;
  state.subjects = [];
  var subjChoice = cfg.querySelector('#subj-choice');
  var mpBox   = cfg.querySelector('#multi-preview');
  var mpGrid  = cfg.querySelector('#mp-grid');
  var mpCount = cfg.querySelector('#mp-count');
  var mpEmpty = cfg.querySelector('#mp-empty');
  var offCanvas = null;
  var subjGen = 0;
  var subjBusy = false;
  var subjTimer = null;
  /* le miniature seguono ogni cambio di configurazione, come l'anteprima singola */
  function refreshSubjects(){
    if(!isMulti() || subjBusy || !state.subjects.length) return;
    clearTimeout(subjTimer);
    subjTimer = setTimeout(renderSubjects, 120);
  }
  function isMulti(){ return state.soggetti === 'multi'; }
  /* Con più soggetti il riquadro resta un invito a caricare la grafica
     successiva: il file appena caricato è già visibile nella griglia sotto. */
  function markZoneLoaded(z, name){
    if(!z){ markLiftLoaded(name); return; }
    var h = z.querySelector('h4'), p = z.querySelector('p');
    if(isMulti()){
      var left = MAX_SUBJ - state.subjects.length;
      if(h) h.textContent = left > 0 ? 'Aggiungi un\u2019altra grafica' : 'Hai caricato tutti i soggetti';
      if(p){ p.hidden = false; p.textContent = left > 0 ? (left + (left === 1 ? ' soggetto ancora disponibile' : ' soggetti ancora disponibili')) : 'Rimuovine uno per cambiarlo'; }
      z.style.borderColor = '';
      return;
    }
    if(h) h.textContent = '✓ ' + name;
    if(p) p.hidden = true;
    z.style.borderColor = 'var(--mint)';
  }
  /* conferma compatta a tutta larghezza dopo ogni grafica caricata */
  function multiBarEl(){
    var col = upCol || cfg.querySelector('.upload-col'); if(!col) return null;
    var bar = col.querySelector('.mp-bar');
    if(!bar){
      bar = document.createElement('div');
      bar.className = 'mp-bar';
      bar.setAttribute('role','status');
      bar.innerHTML = '<span class="mp-bar-fill"></span><span class="mp-bar-icon"><span class="msr">cloud_upload</span></span><span class="mp-bar-copy"><span class="mp-bar-msg">Caricamento delle grafiche…</span><span class="mp-bar-sub">Attendi prima di ordinare.</span></span><span class="mp-bar-pct"></span>';
      var zone = col.querySelector('.upload-zone') || col.querySelector('.upload-lift-shell');
      if(zone && zone.nextSibling) col.insertBefore(bar, zone.nextSibling); else col.appendChild(bar);
    }
    return bar;
  }
  function setMultiBar(mode, pct, completed, total){
    var bar = multiBarEl(); if(!bar) return;
    bar.hidden = false;
    bar.classList.toggle('is-loading', mode === 'loading');
    bar.classList.toggle('is-done', mode === 'done');
    var fill = bar.querySelector('.mp-bar-fill');
    var msg  = bar.querySelector('.mp-bar-msg');
    var sub  = bar.querySelector('.mp-bar-sub');
    var pctE = bar.querySelector('.mp-bar-pct');
    var icon = bar.querySelector('.mp-bar-icon .msr');
    if(mode === 'loading'){
      var done = Math.max(0, completed || 0), all = Math.max(1, total || state.uploadTargetCount || 1);
      var progress = pct == null ? Math.round((done / all) * 100) : Math.min(100, pct);
      if(icon) icon.textContent = 'cloud_upload';
      if(msg) msg.textContent = all > 1 ? 'Stiamo caricando le tue grafiche' : 'Stiamo caricando la tua grafica';
      if(sub) sub.textContent = all > 1 ? (done + ' di ' + all + ' al sicuro · Attendi prima di ordinare.') : 'Tienici aperti ancora un momento.';
      if(fill) fill.style.width = progress + '%';
      if(pctE) pctE.textContent = all > 1 ? (done + '/' + all) : '';
    } else {
      if(icon) icon.textContent = 'check_circle';
      if(msg) msg.textContent = (total || state.uploadTargetCount || 1) > 1 ? 'Tutte le grafiche sono pronte' : 'Grafica pronta';
      if(sub) sub.textContent = 'Ora puoi completare il tuo ordine.';
      if(fill) fill.style.width = '100%';
      if(pctE) pctE.textContent = '';
      bar.classList.remove('is-in'); void bar.offsetWidth; bar.classList.add('is-in');
    }
  }
  /* stesso messaggio, ma sull'etichetta del widget Upload Lift */
  function markLiftLoaded(name){
    var mount = getULMount(); if(!mount) return;
    var h = mount.querySelector('.uplift-ui__title');
    var p = mount.querySelector('.uplift-ui__sub');
    if(isMulti()){
      var left = MAX_SUBJ - state.subjects.length;
      if(h) h.textContent = left > 0 ? 'Aggiungi un\u2019altra grafica' : 'Hai caricato tutti i soggetti';
      if(p) p.textContent = left > 0 ? (left + (left === 1 ? ' soggetto ancora disponibile' : ' soggetti ancora disponibili')) : 'Rimuovine uno per cambiarlo';
      return;
    }
    if(h) h.textContent = '\u2713 ' + (name || 'File caricato');
    if(p) p.textContent = 'File pronto per la stampa · controllo file incluso.';
  }
  /* toglie lo stesso file dalla lista (nascosta) di Upload Lift */
  function ulRemoveItem(i){
    var mount = getULMount(); if(!mount) return;
    var items = mount.querySelectorAll('.filepond--item');
    var it = items[i]; if(!it) return;
    var x = it.querySelector('.filepond--file-action-button[data-align], .filepond--action-remove-item, [class*="action-remove"]');
    if(x) x.click();
  }
  function subjEsc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function setSoggetti(v){
    state.soggetti = v;
    cfg.setAttribute('data-soggetti', v === 'multi' ? 'multi' : '1');
    syncMpBox();
    if(typeof ulSkinAll === 'function'){ ulSkinAll(); ulBindInput(); }
    if(v !== 'multi' && state.subjects.length > 1) state.subjects = state.subjects.slice(0,1);
    renderSubjects();
    render();
  }

  function syncMpBox(){
    var on = isMulti() && state.subjects.length > 0;
    if(mpBox) mpBox.hidden = !on;
    var bar = (upCol || cfg.querySelector('.upload-col') || cfg).querySelector('.mp-bar');
    if(bar && !on) bar.hidden = true;
  }
  function subjCountLabel(){
    syncMpBox();
    if(mpCount) mpCount.textContent = state.subjects.length + ' / ' + MAX_SUBJ;
    if(mpEmpty) mpEmpty.hidden = state.subjects.length > 0;
  }

  /* Ogni soggetto viene renderizzato con il materiale, il taglio e la
     dimensione scelti: passiamo le grafiche una alla volta nel motore di
     anteprima e fotografiamo il risultato. */
  function renderSubjects(){
    if(!mpGrid) return Promise.resolve([]);
    subjCountLabel();
    if(!isMulti()){ mpGrid.innerHTML = ''; return Promise.resolve([]); }
    mpGrid.innerHTML = state.subjects.map(function(s, i){
      return '<figure class="mp-item" data-i="' + i + '">'
        + '<span class="mp-n">' + (i+1) + '</span>'
        + '<button type="button" class="mp-del" data-del="' + i + '" aria-label="Rimuovi soggetto ' + (i+1) + '"><span class="msr">close</span></button>'
        + '<div class="mp-thumb"><span class="mp-spin" aria-hidden="true"></span></div>'
        + '<figcaption>' + subjEsc(s.name || ('Soggetto ' + (i+1))) + '</figcaption>'
        + '</figure>';
    }).join('');
    if(!state.subjects.length) return Promise.resolve([]);
    if(!offCanvas){
      offCanvas = document.createElement('canvas');
      offCanvas.width = 560; offCanvas.height = 560;
      if(window.WowPreview && window.WowPreview.register) window.WowPreview.register(offCanvas);
    }
    var gen = ++subjGen;
    subjBusy = true;
    var chain = Promise.resolve();
    state.subjects.forEach(function(s, i){
      chain = chain.then(function(){
        if(gen !== subjGen) return;              // arrivata una nuova grafica: questo giro non serve più
        return window.WowPreview.setImage(s.src).then(function(){
          if(gen !== subjGen) return;
          updatePreview();
          var slot = mpGrid.querySelector('.mp-item[data-i="' + i + '"] .mp-thumb');
          if(slot){
            var img = new Image();
            img.alt = s.name || ('Soggetto ' + (i+1));
            try{ s.previewPng = offCanvas.toDataURL('image/png'); img.src = s.previewPng; }catch(e){}
            slot.innerHTML = '';
            slot.appendChild(img);
            // stesso sfondo di scena dell'anteprima singola
            var st = cfg.querySelector('.preview-stage');
            var bg = st && st.getAttribute('data-bg');
            if(bg) slot.setAttribute('data-bg', bg); else slot.removeAttribute('data-bg');
            // stesso avviso quando il taglio richiede l'intervento dei grafici
            if(manualAdaptState()){
              var w = document.createElement('span');
              w.className = 'mp-adapt';
              w.innerHTML = '<span class="msr">content_cut</span>Adattamento a cura dei grafici';
              slot.appendChild(w);
            }
          }
        }).catch(function(){});
      });
    });
    state.subjectRenderPromise = chain.then(function(){
      if(gen === subjGen) subjBusy = false;
      return state.subjects.map(function(s){ return s.previewPng || null; });
    });
    // l'ultimo soggetto resta caricato nel motore di anteprima
    return state.subjectRenderPromise;
  }

  if(mpGrid) mpGrid.addEventListener('click', function(e){
    var btn = e.target.closest('[data-del]'); if(!btn) return;
    var idx = +btn.getAttribute('data-del');
    ulRemoveItem(idx);
    state.subjects.splice(idx, 1);
    if(state.originalFileUrls) state.originalFileUrls.splice(idx, 1);
    if(state.fileUrls) state.fileUrls = state.originalFileUrls.slice();
    state.fileUrl = state.originalFileUrls[0] || '';
    state.uploadTargetCount = state.subjects.length;
    if(state.uploading){
      if(!state.uploadTargetCount){ state.uploading = false; setNextDisabled(false); syncMpBox(); }
      else if(state.originalFileUrls.length >= state.uploadTargetCount) finishUpload({ name:state.fileName || 'Grafiche' });
      else setMultiBar('loading', null, state.originalFileUrls.length, state.uploadTargetCount);
    }
    if(!state.subjects.length){ state.file = false; state.fileUrl = ''; }
    renderSubjects(); render();
  });

  const upZone = cfg.querySelector('.upload-zone');
  const upInput = cfg.querySelector('#cfg-file');
  if(upZone){
    upZone.addEventListener('click', ()=> upInput && upInput.click());
    // drag & drop
    ['dragover','dragenter'].forEach(ev=>upZone.addEventListener(ev,e=>{e.preventDefault(); upZone.style.borderColor='var(--red)';}));
    ['dragleave','drop'].forEach(ev=>upZone.addEventListener(ev,e=>{e.preventDefault();}));
    upZone.addEventListener('drop', e=>{ handleFiles(e.dataTransfer.files); });
    if(upInput) upInput.addEventListener('change', ()=>{ handleFiles(upInput.files); });
  }
  /* in modalità multipla accettiamo più file per volta, uno dopo l'altro */
  function handleFiles(fileList){
    var files = Array.prototype.slice.call(fileList || []);
    if(!files.length) return;
    if(!isMulti()) files = files.slice(0,1);
    if(isMulti()){
      files = files.slice(0, Math.max(0, MAX_SUBJ - state.subjects.length));
      state.uploadTargetCount = Math.min(MAX_SUBJ, state.subjects.length + files.length);
      setMultiBar('loading', null, (state.originalFileUrls || []).length, state.uploadTargetCount);
    } else state.uploadTargetCount = 1;
    files.slice(0, MAX_SUBJ).forEach(function(f, i){ setTimeout(function(){ handleFile(f); }, i * 60); });
  }
  function acceptNoPreview(f){
    state.file=true;
    clearStepAlert();
    const z=cfg.querySelector('.upload-zone');
    markZoneLoaded(z, f.name);
    if(chipsBox) chipsBox.innerHTML='<span class="echip"><span class="msr ic">verified</span> File pronto · controllo incluso</span>';
    render();
  }
  function showPdfNote(multi){
    const n=cfg.querySelector('#pdf-note'), t=cfg.querySelector('#pdf-note-txt');
    if(!n||!t) return;
    t.textContent=(multi?'Anteprima della prima pagina. ':'')+'Anteprima indicativa: i colori di stampa possono variare leggermente. Ogni file viene controllato a mano prima della produzione.';
    n.hidden=false;
  }
  // Lazy-load PDF.js only when a PDF is actually uploaded.
  // In produzione: sostituire gli URL CDN con gli asset locali del tema Shopify.
  let pdfLibP=null;
  function loadPdfJs(){
    if(window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if(pdfLibP) return pdfLibP;
    pdfLibP=new Promise((res,rej)=>{
      const s=document.createElement('script');
      s.src='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
      s.onload=()=>{ try{ window.pdfjsLib.GlobalWorkerOptions.workerSrc='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js'; }catch(e){} res(window.pdfjsLib); };
      s.onerror=rej; document.head.appendChild(s);
    });
    return pdfLibP;
  }
  function handlePdf(f){
    if(chipsBox) chipsBox.innerHTML='<span class="echip"><span class="msr ic">content_cut</span> ✂️ Preparo il tuo sticker…</span>';
    loadPdfJs().then((pdfjsLib)=>{
      const fr=new FileReader();
      fr.onload=()=>{
        pdfjsLib.getDocument({ data:fr.result }).promise.then((pdf)=>{
          const pages=pdf.numPages;
          pdf.getPage(1).then((page)=>{
            const vp0=page.getViewport({scale:1});
            const scale=Math.min(3, 1200/Math.max(vp0.width, vp0.height));
            const vp=page.getViewport({scale:scale});
            const cv=document.createElement('canvas'); cv.width=Math.round(vp.width); cv.height=Math.round(vp.height);
            const cx=cv.getContext('2d'); cx.fillStyle='#fff'; cx.fillRect(0,0,cv.width,cv.height);
            page.render({ canvasContext:cx, viewport:vp }).promise.then(()=>{
              loadIntoPreview(cv.toDataURL('image/png'), f.name);
              showPdfNote(pages>1);
            }).catch(()=>acceptNoPreview(f));
          }).catch(()=>acceptNoPreview(f));
        }).catch(()=>acceptNoPreview(f));
      };
      fr.onerror=()=>acceptNoPreview(f);
      fr.readAsArrayBuffer(f);
    }).catch(()=>acceptNoPreview(f));
  }
  function addSubject(src, name){
    if(!isMulti()){ state.subjects = [{ src:src, name:name }]; return; }
    if(state.subjects.length >= MAX_SUBJ){
      showStepAlert('Puoi caricare al massimo ' + MAX_SUBJ + ' soggetti. Rimuovine uno per aggiungerne un altro.');
      return;
    }
    state.subjects.push({ src:src, name:name });
    renderSubjects();
  }
  function handleFile(f){
    const pdfNote=cfg.querySelector('#pdf-note'); if(pdfNote) pdfNote.hidden=true;
    if(isMulti() && state.subjects.length >= MAX_SUBJ){
      showStepAlert('Puoi caricare al massimo ' + MAX_SUBJ + ' soggetti. Rimuovine uno per aggiungerne un altro.');
      return;
    }
    beginUpload(f);
    if(/(png|jpe?g)$/i.test(f.name) && f.type.indexOf('image')===0){
      const r=new FileReader();
      r.onload=()=>loadIntoPreview(r.result, f.name);
      r.readAsDataURL(f);
    } else if(/\.pdf$/i.test(f.name) || f.type==='application/pdf'){
      handlePdf(f);
    } else {
      acceptNoPreview(f);
    }
  }
  // demo example (uses the WowSticker logo, which has transparency)
  const demoBtn = cfg.querySelector('#cfg-demo');
  if(demoBtn) demoBtn.addEventListener('click', ()=>{ const pn=cfg.querySelector('#pdf-note'); if(pn) pn.hidden=true; if(upStatus){ clearInterval(upTimer); upStatus.hidden=true; upStatus.classList.remove('is-overlay'); if(upDim) upDim.hidden=true; state.uploading=false; setNextDisabled(false); } state.fileUrl='https://cdn.uploadlift.app/wowsticker/demo/logo-wowsticker.png'; loadIntoPreview((window.WOW_ASSET_BASE||'')+'wowsticker-logo.png','Esempio: logo WowSticker'); });

  // white-border toggle (tondo / quadrato)
  const bordoInput = cfg.querySelector('#cfg-bordo');
  if(bordoInput) bordoInput.addEventListener('change', ()=>{ state.bordoBianco = bordoInput.checked; var lbl=bordoInput.closest('.border-toggle'); if(lbl) lbl.classList.toggle('is-on', bordoInput.checked); render(); updatePreview(); });

  // include-background toggle (dark/colored bg + sagomato / kiss-cut)
  const sfondoInput = cfg.querySelector('#cfg-sfondo');
  if(sfondoInput) sfondoInput.addEventListener('change', ()=>{ state.sfondoIncluso = sfondoInput.checked; render(); updatePreview(); });

  // DTF: remove-background-from-print toggle (prespaziato effect on fabric)
  const dtfRemoveInput = cfg.querySelector('#cfg-dtf-remove');
  if(dtfRemoveInput) dtfRemoveInput.addEventListener('change', ()=>{ state.dtfRemoveBg = dtfRemoveInput.checked; render(); updatePreview(); });

  // Prespaziati: application-tape overlay toggle
  const vinylTapeInput = cfg.querySelector('#cfg-vinyl-tape');
  if(vinylTapeInput) vinylTapeInput.addEventListener('change', ()=>{ state.vinylTape = vinylTapeInput.checked; var lbl=vinylTapeInput.closest('.border-toggle'); if(lbl) lbl.classList.toggle('is-on', vinylTapeInput.checked); render(); updatePreview(); });

  // Anteprima di stampa (proof) — Sì/No button group, gratuita (line item property)
  cfg.querySelectorAll('#proof-toggle .pc-btn').forEach(function(b){
    b.addEventListener('click', function(){
      cfg.querySelectorAll('#proof-toggle .pc-btn').forEach(function(x){ var on = x===b; x.setAttribute('aria-pressed', on?'true':'false'); x.setAttribute('aria-checked', on?'true':'false'); });
    });
  });
  var proofInfoBtn = cfg.querySelector('#proof-info-btn'), proofTip = cfg.querySelector('#proof-tip');
  if(proofInfoBtn && proofTip) proofInfoBtn.addEventListener('click', function(){ var open = proofTip.hidden; proofTip.hidden = !open; proofInfoBtn.setAttribute('aria-expanded', open?'true':'false'); proofInfoBtn.classList.toggle('is-open', open); });

  // Geometric cut: remove colored background from the print
  const geoRemoveInput = cfg.querySelector('#cfg-geo-remove');
  if(geoRemoveInput) geoRemoveInput.addEventListener('change', ()=>{ state.geoRemoveBg = geoRemoveInput.checked; render(); updatePreview(); });

  // nav buttons (step-nav, summary and mobile sticky bar all share .btn-next)
  cfg.querySelectorAll('.btn-next').forEach(function(btn){
    btn.addEventListener('click', ()=>{
      var v = stepValid(cur);
      if(!v.ok){ showStepAlert(v.msg); return; }
      clearStepAlert();
      if(cur < steps.length-1){ showStep(cur+1); }
      else if(presTooSmall()){ showStepAlert('Per gli sticker prespaziati la misura minima è 7×7 cm (49 cm²). Contattaci per un preventivo.'); } else { addToCart(); }
    });
  });

  // ---- add to cart: build line-item properties from the current config, open confirm popup ----
  function buildLineItemProps(){
    var p = computePrice();
    var props = {};
    props['Materiale'] = state.tipoLabel || '—';
    // per i prespaziati "Taglio: Prespaziato" ripete il materiale: non serve
    if(state.tipo !== 'prespaziato') props['Taglio'] = state.taglioLabel || '—';
    var det = cutDetails();
    if(det.border) props['Bordo'] = det.border;
    if(det.finitura) props['Finitura'] = det.finitura;
    var sz = cfg.querySelector('#sum-size'); props['Dimensione'] = sz ? sz.textContent : (state.sizeLabel||'—');
    props['Quantità'] = state.qty ? (state.qty + ' pz') : '—';
    if(isMulti()) props['Soggetti'] = state.subjects.length + (state.subjects.length === 1 ? ' grafica' : ' grafiche');
    if(state.tipo==='prespaziato' && state.coloreName) props['Colore'] = state.coloreName;
    var pfYes = cfg.querySelector('#proof-toggle .pc-btn[data-proof="yes"]'); props['Anteprima di stampa'] = (pfYes && pfYes.getAttribute('aria-pressed')==='true') ? 'Sì · gratuita' : 'No';
    if(p && p.total!=null) props['Prezzo'] = fmt(p.total) + (state.qty?(' ('+fmt(p.unit)+'/pz)'):'');
    return props;
  }
  /* L'anteprima renderizzata nel configuratore viene caricata come file, così in
     ordine c'è un link scaricabile del render oltre al file originale del cliente.
     Percorso preferito: la stessa istanza FilePond di Upload Lift. In alternativa
     un endpoint proxy (window.WOW_SNAPSHOT_ENDPOINT). Se nessuno dei due risponde
     entro il timeout, l'ordine prosegue senza bloccare il cliente. */
  function dataUrlToFile(dataUrl, name){
    try{
      var parts = dataUrl.split(',');
      var mime = (parts[0].match(/:(.*?);/) || [null,'image/png'])[1];
      var bin = atob(parts[1]);
      var len = bin.length, u8 = new Uint8Array(len);
      while(len--) u8[len] = bin.charCodeAt(len);
      return new File([u8], name, { type: mime });
    }catch(e){ return null; }
  }
  function snapshotFileName(index){
    var bits = ['anteprima' + (index ? '_' + index : ''), state.tipo || 'sticker'];
    if(state.size) bits.push(String(state.size).replace('x','-'));
    if(state.qty) bits.push(state.qty + 'pz');
    return bits.join('-').toLowerCase() + '.png';
  }
  function uploadSnapshot(dataUrl, index, alreadyKnown){
    return new Promise(function(resolve){
      if(!dataUrl){ resolve(null); return; }
      var file = dataUrlToFile(dataUrl, snapshotFileName(index));
      if(!file){ resolve(null); return; }
      var known = {}; (state.fileUrls || []).forEach(function(u){ known[u] = 1; });
      if(state.fileUrl) known[state.fileUrl] = 1;
      (alreadyKnown || []).forEach(function(u){ known[u] = 1; });
      var done = false;
      function finish(url){ if(!done){ done = true; resolve(url || null); } }

      // A) stessa istanza FilePond di Upload Lift
      var pondRoot = getULMount() && getULMount().querySelector('.filepond--root');
      var added = false;
      if(pondRoot && window.FilePond && typeof window.FilePond.find === 'function'){
        try{ var pond = window.FilePond.find(pondRoot); if(pond && pond.addFile){ pond.addFile(file); added = true; } }catch(e){}
      }
      // Cloudlift non espone FilePond come globale: in quel caso passiamo dal suo
      // input file. Lo facciamo solo a upload del cliente già concluso, così non
      // possiamo sovrascrivere una selezione in corso.
      if(!added && pondRoot && state.fileUrl && window.DataTransfer){
        try{
          var input = pondRoot.querySelector('input.filepond--browser') || pondRoot.querySelector('input[type="file"]');
          if(input && !input.files.length){
            var dt = new DataTransfer(); dt.items.add(file);
            input.files = dt.files;
            input.dispatchEvent(new Event('change', { bubbles:true }));
            added = true;
          }
        }catch(e){}
      }
      if(added){
        var tries = 0;
        (function look(){
          if(done) return;
          var urls = [];
          var mount = getULMount();
          if(mount){
            mount.querySelectorAll('[href],[src],[value],[data-url],[data-file-url],[data-upload-url]').forEach(function(n){
              ['href','src','value','data-url','data-file-url','data-upload-url'].forEach(function(at){ var v = n.getAttribute && n.getAttribute(at); if(v) collectULUrls(v, urls); });
            });
          }
          try{
            var raw = window.localStorage && localStorage.getItem('cl_files');
            if(raw) collectULUrls(JSON.parse(raw), urls);
          }catch(e){}
          var fresh = uniq(urls.map(normalizeULUrl)).filter(function(u){ return u && !known[u]; });
          if(fresh.length){ finish(fresh[fresh.length-1]); return; }
          if(++tries < 30) setTimeout(look, 700); else finish(null);
        })();
        return;
      }

      // B) endpoint proxy dedicato
      var endpoint = window.WOW_SNAPSHOT_ENDPOINT;
      if(!endpoint){ finish(null); return; }
      var fd = new FormData();
      fd.append('file', file, file.name);
      fetch(endpoint, { method:'POST', credentials:'same-origin', body: fd })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(d){ finish(d && (d.url || d.fileUrl || d.href)); })
        .catch(function(){ finish(null); });
      setTimeout(function(){ finish(null); }, 12000);
    });
  }

  function waitForOriginalFiles(expected){
    return new Promise(function(resolve){
      var tries = 0;
      (function check(){
        ulScanMount(); ulScanStorage(true);
        var formProps = extractFormProperties();
        var urls = uniq((state.originalFileUrls || []).concat(originalUrlsInProps(formProps)).map(normalizeULUrl));
        state.originalFileUrls = urls;
        state.fileUrls = urls.slice();
        state.fileUrl = urls[0] || '';
        if(urls.length >= expected || !hasUploadLift() || ++tries >= 30){ resolve(urls.slice(0, expected)); return; }
        setTimeout(check, 500);
      })();
    });
  }
  function authoritativePrice(item){
    var endpoint = window.WOW_PRICE_ENDPOINT || '/apps/wowsticker/price';
    return fetch(endpoint, {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      credentials:'same-origin',
      body:JSON.stringify({ tipo:item.tipo, handle:item.handle||null, pricing:item.pricing })
    }).then(function(response){
      if(!response.ok) throw new Error('HTTP '+response.status);
      return response.json();
    }).then(function(data){
      var total = data && data.price && +data.price.total;
      if(!(total >= 0)) throw new Error('Prezzo server non valido');
      return total;
    });
  }
  function addToCart(){
    // ultima chance: l'URL può essere arrivato dopo (widget, storage, form)
    if(!state.fileUrl){ ulScanMount(); ulScanStorage(true); }
    var baseProps = buildLineItemProps();
    var p = computePrice();
    syncProductFormProps(baseProps, state.fileUrl || '');
    var props = cleanOrderFileProperties(extractFormProperties());
    Object.keys(baseProps).forEach(function(k){ props[k] = baseProps[k]; });

    // ---- export a due canali (come Sticker in Foglio) — tutto simulato lato client ----
    var snapId = Date.now().toString(36) + Math.random().toString(36).slice(2,6);
    // CANALE 1 · file originale del cliente (Upload Lift): placeholder URL
    var fallbackFileUrl = state.fileUrl || ((state.file && !hasUploadLift()) ? ('https://placeholder.upload/file-' + snapId) : '');
    // CANALE 2 · snapshot del configuratore (CDN Shopify): render pulito + placeholder URL
    var snapshotPng = (window.WowPreview && window.WowPreview.getCutoutDataURL) ? window.WowPreview.getCutoutDataURL() : null;
    var snapshotUrl = 'https://placeholder.cdn/snapshot-' + snapId + '.png';
    setNextDisabled(true);
    var expected = isMulti() ? state.subjects.length : 1;
    setOrderBusy({ phase:'check', count:expected });
    waitForOriginalFiles(expected).then(function(originals){
      if(!originals.length && fallbackFileUrl) originals = [fallbackFileUrl];
      if(hasUploadLift() && originals.length < expected){
        setOrderBusy(null); setNextDisabled(false);
        showStepAlert('Uno o più file non hanno terminato il caricamento. Attendi qualche secondo e premi di nuovo Ordina ora.');
        return null;
      }
      setOrderBusy({ phase:'prepare', count:expected });
      return (isMulti() ? renderSubjects() : Promise.resolve([snapshotPng])).then(function(previews){
        var uploaded = [], chain = Promise.resolve();
        state.previewUploading = true;
        /* anteprime non piu caricate su Upload Lift: al carrello va solo File */ previews.slice(0, 0).forEach(function(png, i){
          chain = chain.then(function(){
            return uploadSnapshot(png, i + 1, originals.concat(uploaded)).then(function(url){ uploaded[i] = url || ''; });
          });
        });
        return chain.then(function(){ state.previewUploading = false; return { originals:originals, previews:uploaded }; }, function(){ state.previewUploading = false; return { originals:originals, previews:uploaded }; });
      });
    }).then(function(files){
      if(!files) return;
      if(isMulti()){
        files.originals.forEach(function(url, i){ props['File_' + (i+1)] = url; });
        files.previews.forEach(function(url, i){ if(url) props['Anteprima_' + (i+1)] = url; });
        delete props.File; delete props.Anteprima; delete props._file_originali;
      } else {
        if(files.originals[0]) props.File = files.originals[0];
        var onePreview = ''; // nessuna Anteprima nelle line properties: solo File
        if(onePreview) props.Anteprima = onePreview;
        props._file_originali = files.originals[0] || '';
        setProductFormProp('Anteprima', onePreview);
      }
      if(files.previews.some(function(url){ return !url; }) && hasUploadLift()){
        try{ console.warn('[WowSticker] una o più anteprime non sono state caricate'); }catch(e){}
      }

      var item = {
        title: (state.tipo==='etichette' ? 'Etichette' : ('Sticker ' + (state.tipoLabel || ''))),
        tipo: state.tipo,
        price: (p && p.total!=null) ? p.total : 0,   // per configured job (this qty is a property)
        quantity: 1,
        pricing: {
          mode: state.size === 'custom' ? 'custom' : 'standard',
          widthCm: state.size === 'custom' ? state.customW : +(String(state.size).split('x')[0]),
          heightCm: state.size === 'custom' ? state.customH : +(String(state.size).split('x')[1]),
          quantity: state.qty
        },
        image: isMulti() ? ((state.subjects[0] && state.subjects[0].previewPng) || snapshotPng) : snapshotPng,
        properties: props
      };
      authoritativePrice(item).catch(function(error){
        try{ console.warn('[WowSticker] verifica prezzo rimandata al checkout', error); }catch(e){}
        return item.price;
      }).then(function(serverTotal){
        item.price = serverTotal;
        if(p && state.qty) item.properties.Prezzo = fmt(serverTotal)+' ('+fmt(serverTotal/state.qty)+'/pz)';
        if(window.WowCart){ try{ window.WowCart.add(item); }catch(e){} }
        try{ console.log('[WowSticker] add to cart · line item', item); }catch(e){}
        setOrderBusy({ phase:'done', count:expected });
        // Lasciamo vedere la conferma per un istante, poi passiamo al carrello.
        setTimeout(function(){ window.location.href = window.WOW_CART_URL || 'Carrello.html'; }, 650);
      });
    });
  }
  /* Attesa guidata: copre la parte tecnica della preparazione e rassicura il
     cliente mentre completiamo il lavoro prima di aprire il carrello. */
  var orderWaitEl = null;
  var orderWaitPhraseTimer = null;
  var orderWaitPhraseIndex = 0;
  var ORDER_WAIT_PHRASES = {
    check: [
      'Questa frase esiste solo per distrarti dall’attesa. Sta funzionando?',
      'Il tuo ordine è in buone mani. Lo giuriamo!',
      'Stiamo contando i file. Sì, sappiamo contare fino a cinque.',
      'Controlliamo che tu non abbia ordinato 4.000 adesivi per sbaglio. Era voluto? Daje.'
    ],
    prepare: [
      'Le tue grafiche si stanno mettendo in posa.',
      'Stiamo facendo il lavoro invisibile che farà sembrare tutto facilissimo.',
      'Nel frattempo puoi ripensare a quell’adesivo che non hai aggiunto al carrello.',
      'Nessun file è stato maltrattato durante questa preparazione.'
    ],
    done: [
      'Perfetto. Persino il carrello è emozionato.'
    ]
  };
  function ensureOrderWait(){
    if(orderWaitEl) return orderWaitEl;
    orderWaitEl = document.createElement('div');
    orderWaitEl.className = 'order-wait';
    orderWaitEl.hidden = true;
    orderWaitEl.setAttribute('role','dialog');
    orderWaitEl.setAttribute('aria-modal','true');
    orderWaitEl.setAttribute('aria-labelledby','order-wait-title');
    orderWaitEl.innerHTML = '<div class="order-wait-card">'
      + '<div class="order-wait-art" aria-hidden="true"><span class="ow-sheet ow-sheet-a"></span><span class="ow-sheet ow-sheet-b"></span><span class="ow-core"><span class="msr">auto_awesome</span></span></div>'
      + '<div class="order-wait-kicker">Ci siamo quasi</div>'
      + '<h2 id="order-wait-title">Prepariamo il tuo ordine</h2>'
      + '<p class="order-wait-copy" aria-live="polite">Un ultimo controllo e sarai subito al carrello.</p>'
      + '<div class="order-wait-progress" aria-hidden="true"><i></i></div>'
      + '<div class="order-wait-steps" aria-hidden="true"><span data-ow-step="check"><b class="msr">check</b>Controllo</span><span data-ow-step="prepare"><b class="msr">auto_awesome</b>Preparazione</span><span data-ow-step="done"><b class="msr">shopping_bag</b>Carrello</span></div>'
      + '<small><span class="msr">lock</span> Non chiudere questa pagina: ti portiamo avanti automaticamente.</small>'
      + '</div>';
    document.body.appendChild(orderWaitEl);
    return orderWaitEl;
  }
  function startOrderWaitPhrases(phase){
    clearInterval(orderWaitPhraseTimer);
    orderWaitPhraseTimer = null;
    var phrases = ORDER_WAIT_PHRASES[phase] || ORDER_WAIT_PHRASES.check;
    var copy = ensureOrderWait().querySelector('.order-wait-copy');
    orderWaitPhraseIndex = 0;
    function showPhrase(){
      var next = phrases[orderWaitPhraseIndex % phrases.length];
      orderWaitPhraseIndex++;
      copy.classList.add('is-changing');
      setTimeout(function(){ copy.textContent = next; copy.classList.remove('is-changing'); }, 150);
    }
    showPhrase();
    if(phrases.length > 1) orderWaitPhraseTimer = setInterval(showPhrase, 3400);
  }
  function setOrderBusy(status){
    var overlay = ensureOrderWait();
    var active = !!status;
    cfg.querySelectorAll('.btn-next').forEach(function(b){
      if(active){
        if(!b.getAttribute('data-label')) b.setAttribute('data-label', b.innerHTML);
        b.setAttribute('disabled','');
      } else {
        var lbl = b.getAttribute('data-label');
        if(lbl){ b.innerHTML = lbl; b.removeAttribute('data-label'); }
        b.removeAttribute('disabled');
      }
    });
    if(!active){
      clearInterval(orderWaitPhraseTimer); orderWaitPhraseTimer = null;
      document.body.classList.remove('order-is-busy');
      overlay.classList.remove('is-show');
      setTimeout(function(){ if(!overlay.classList.contains('is-show')) overlay.hidden = true; }, 240);
      return;
    }
    var phase = status.phase || 'check';
    var title = overlay.querySelector('#order-wait-title');
    if(phase === 'check'){
      title.textContent = 'Prepariamo il tuo ordine';
    } else if(phase === 'prepare'){
      title.textContent = 'Sta venendo tutto benissimo';
    } else {
      title.textContent = 'Tutto pronto!';
    }
    overlay.setAttribute('data-phase', phase);
    overlay.querySelectorAll('[data-ow-step]').forEach(function(s){
      var order = {check:1,prepare:2,done:3};
      s.classList.toggle('is-on', order[s.getAttribute('data-ow-step')] <= order[phase]);
    });
    overlay.hidden = false;
    document.body.classList.add('order-is-busy');
    startOrderWaitPhrases(phase);
    requestAnimationFrame(function(){ overlay.classList.add('is-show'); });
  }
  (function(){
    var modal = document.getElementById('cart-modal');
    if(!modal) return;
    function close(){ modal.classList.remove('show'); setTimeout(function(){ modal.hidden = true; }, 220); }
    var cont = document.getElementById('cm-continue'); if(cont) cont.addEventListener('click', close);
    var cart = document.getElementById('cm-cart'); if(cart) cart.addEventListener('click', function(){ window.location.href = 'Carrello.html'; });
    modal.addEventListener('click', function(e){ if(e.target===modal) close(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !modal.hidden) close(); });
  })();
  cfg.querySelector('.link-back').addEventListener('click', ()=> showStep(cur-1));

  // jump via pips
  pips.forEach((p,idx)=> p.addEventListener('click', ()=>{
    if(idx<=cur){ showStep(idx); return; }               // indietro: sempre consentito
    if(idx===cur+1){                                       // avanti di uno: solo se lo step è valido
      var v = stepValid(cur);
      if(v.ok){ showStep(idx); } else { showStepAlert(v.msg); }
    }
  }));

  function fmt(n){ return '€' + n.toLocaleString('it-IT',{minimumFractionDigits:2, maximumFractionDigits:2}); }
  function trimNum(n){ return String(Math.round((+n)*10)/10); }

  function unitPriceFor(qty){
    if(!state.tipo || !state.size || !qty) return null;
    if(state.size==='custom'){
      if(!(state.customW>0) || !(state.customH>0)) return null;
      if(presTooSmall()) return null; var pc = C.priceCustom(state.tipo, state.customW, state.customH, qty);
      return pc==null ? null : pc.unit;
    }
    var pr = C.priceFor(state.tipo, state.size, qty);
    return pr==null ? null : pr/qty;
  }
  function updateQtyBadges(){
    var btns = cfg.querySelectorAll('.qty-grid-real .qty-opt');
    if(!btns.length) return;
    btns.forEach(function(b){
      var save = b.querySelector('.qty-save'); if(!save) return;
      var u = unitPriceFor(parseInt(b.getAttribute('data-value'),10));
      if(u!=null){ save.textContent = fmt(u)+'/pz'; save.hidden = false; }
      else { save.textContent = ''; save.hidden = true; }
    });
  }

  function computePrice(){
    if(!state.tipo || !state.size || !state.qty) return null;
    if(state.size==='custom'){
      if(!(state.customW>0) || !(state.customH>0)) return null;
      if(presTooSmall()) return { needsQuote:true }; const pc = C.priceCustom(state.tipo, state.customW, state.customH, state.qty);
      return pc==null ? { needsQuote:true } : pc;
    }
    const pr = C.priceFor(state.tipo, state.size, state.qty);
    if(pr==null) return { needsQuote:true };
    return { unit: pr/state.qty, total: pr };
  }

  /* Dettagli del taglio, separati per poterli esporre come line properties
     distinte (Taglio / Bordo / Sfondo / Finitura) invece di un'unica stringa. */
  function cutDetails(){
    var mm = borderMMval(), cm = cutMode(), border = '', sfondo = '', finitura = '';
    var hasPlate = window.WowPreview && window.WowPreview.hasBackgroundPlate && window.WowPreview.hasBackgroundPlate();
    if(state.sfondoIncluso && hasPlate) sfondo = 'sfondo incluso';
    var geo = (cm==='rect'||cm==='rounded'||cm==='circle');
    var contour = (cm==='contour'||cm==='sheet');
    if(state.tipo==='prespaziato'){
      // il colore ha già la sua property dedicata
    } else if(state.tipo==='dtf'){
      finitura = 'pronto da stirare';
      if(state.dtfRemoveBg) sfondo = 'sfondo rimosso';
    } else if(state.tipo==='trasparente'){
      if(contour) border = 'margine trasparente ' + mm + ' mm';
    } else if(state.tipo==='olografico'){
      if(geo) border = state.bordoBianco ? ('bordo holo +' + mm + ' mm') : 'No';
      else if(contour) border = 'margine holo ' + mm + ' mm';
    } else if(state.tipo==='oro'){
      if(geo) border = state.bordoBianco ? ('bordo oro +' + mm + ' mm') : 'No';
      else if(contour) border = 'margine oro ' + mm + ' mm';
    } else if(state.tipo==='stampataglio'){
      if(state.vinylTape) finitura = 'su pellicola di trasporto';
    } else if(state.tipo==='mezzotaglio'){
      finitura = 'supporto siliconato attorno al taglio';
    } else {
      // sui tagli geometrici il bordo è opzionale: se non scelto lo dichiariamo comunque
      if(geo) border = state.bordoBianco ? ('bordo bianco +' + mm + ' mm') : 'No';
      else if(contour) border = 'bordo bianco ' + mm + ' mm';
    }
    var all = [];
    if(state.tipo==='prespaziato' && state.coloreName) all.push(state.coloreName);
    if(sfondo) all.push(sfondo);
    if(finitura) all.push(finitura);
    if(border && border !== 'No') all.push(border);
    return { border: border, sfondo: sfondo, finitura: finitura, all: all };
  }

  function render(){
    if(productForm) syncProductFormProps(buildLineItemProps(), state.fileUrl || '');
    const setVal = (id,val,empty)=>{
      const el = cfg.querySelector('#'+id);
      if(!el) return;
      const li = el.closest('li');
      el.textContent = val || empty;
      if(li) li.classList.toggle('empty', !val);
    };
    setVal('sum-tipo', state.tipoLabel, 'Da scegliere');
    var d = cutDetails();
    var suffix = d.all.length ? (' · ' + d.all.join(' · ')) : '';
    var taglioTxt = state.taglioLabel ? (state.taglioLabel + suffix) : null;
    setVal('sum-taglio', taglioTxt, 'Da scegliere');
    const szLabel = orientedSizeLabel();
    const rectSize = isRectSize(state.size);
    const sumSizeTxt = state.size ? (szLabel + (rectSize ? ' · '+orientWord() : '')) : null;
    setVal('sum-size', sumSizeTxt, 'Da scegliere');
    setVal('sum-qty', state.qty ? state.qty + ' pz' : null, 'Da scegliere');
    updateQtyBadges();

    const p = computePrice();
    const pv = cfg.querySelector('#sum-price');
    const pu = cfg.querySelector('#sum-unit');
    var prod = (window.WowCatalog && state.tipo) ? window.WowCatalog.PRODUCTS.find(function(x){ return x.key===state.tipo; }) : null;
    var fromTxt = prod ? ('da €' + prod.start) : '—';
    if(p && p.needsQuote){
      pv.textContent = 'Su richiesta';
      pu.innerHTML = 'Combinazione fuori listino — <a href="#contatti">contattaci</a> per il preventivo';
    } else if(p){
      pv.textContent = fmt(p.total);
      pu.textContent = fmt(p.unit) + ' / pz · IVA inclusa';
    } else if(prod){
      pv.textContent = fromTxt;
      pu.textContent = '';
    } else {
      pv.textContent = '—';
      pu.textContent = 'Completa i passaggi per il prezzo';
    }
    // mobile sticky summary bar
    var mLabel = document.getElementById('msum-label');
    var mPrice = document.getElementById('msum-price');
    if(mLabel && mPrice){
      var mparts = [];
      if(state.tipoLabel) mparts.push(state.tipoLabel);
      if(state.taglioLabel) mparts.push(state.taglioLabel);
      if(state.size) mparts.push(szLabel);
      if(state.qty) mparts.push(state.qty + ' pz');
      mLabel.textContent = mparts.length ? mparts.join(' · ') : 'Scegli il materiale per iniziare…';
      if(p && p.needsQuote) mPrice.textContent = 'Su richiesta';
      else if(p) mPrice.textContent = fmt(p.total);
      else mPrice.textContent = fromTxt;
    }
    // custom-size note: show the live, exact €/m² rate
    const scRate = cfg.querySelector('#sc-rate');
    if(scRate){
      if(state.size==='custom'){
        const rate = (window.WowCatalog && state.tipo && state.qty) ? window.WowCatalog.ratePerM2(state.tipo, state.qty) : null;
        const ruled = (window.WowCatalog && state.tipo) ? window.WowCatalog.adminRules(state.tipo) : null;
        if(rate!=null){
          var detail = p && p.tierLines ? p.tierLines.map(function(line){ return trimNum(line.mq)+' m² × '+fmt(line.rate); }).join(' + ') : '';
          var floorNote = p && p.floorApplied && p.standardFloor ? ' · minimo listino '+trimNum(p.standardFloor.format.w)+'×'+trimNum(p.standardFloor.format.h)+' applicato' : '';
          scRate.innerHTML = 'Prezzo <strong>progressivo al m²</strong>: quota fissa '+fmt((p&&p.fixedOrderFee)||((ruled&&ruled.fixedOrderFee)!=null?ruled.fixedOrderFee:20))+(detail?' + '+detail:'')+floorNote+' · IVA inclusa.';
        } else {
          scRate.innerHTML = 'Prezzo <strong>calcolato al m²</strong> in tempo reale · IVA inclusa. Scegli la quantità.';
        }
      }
    }
    const eta = cfg.querySelector('#sum-eta-val');
    if(eta) eta.textContent = state.qty ? (ETA[state.qty]||'5–7 giorni') : 'in 3–7 giorni';

    // mini preview swatch in summary follows tipo
    const sv = cfg.querySelector('#sum-vis');
    if(sv && state.tipoLabel){ sv.setAttribute('data-label', state.tipoLabel + (state.file?' · file ✓':'')); }
  }

  /* ---------- Public API: preset from the "Trova lo sticker giusto" guide ---------- */
  window.WowConfig = {
    applyPreset(p){
      const pick = (group, match)=>{
        const opts = Array.from(cfg.querySelectorAll('.opt[data-group="'+group+'"]'));
        const opt = opts.find(o=> o.dataset.value===String(match) || o.dataset.label===match || (o.querySelector('.opt-t')||{}).textContent===match);
        if(!opt) return;
        opts.forEach(o=>o.classList.remove('sel'));
        opt.classList.add('sel');
        const val = opt.dataset.value;
        const label = opt.dataset.label || opt.querySelector('.opt-t').textContent;
        if(group==='tipo'){ state.tipo=val; state.tipoLabel=label; }
        if(group==='taglio'){ state.taglio=val; state.taglioLabel=label; }
        if(group==='size'){ state.size=val; state.sizeLabel=label; }
        if(group==='qty'){ state.qty=parseInt(val,10); }
      };
      if(p.tipo) pick('tipo', p.tipo);
      if(p.taglio) pick('taglio', p.taglio);
      if(p.size==='custom'){
        pick('size','custom'); toggleCustomSize(true);
        state.customW = parseFloat(p.w)||null; state.customH = parseFloat(p.h)||null;
        const cw=cfg.querySelector('#cw'), ch=cfg.querySelector('#ch');
        if(cw && p.w) cw.value = trimNum(p.w);
        if(ch && p.h) ch.value = trimNum(p.h);
      } else if(p.size){ pick('size', p.size); }
      if(p.qty) pick('qty', p.qty);
      // orientation preset — an explicit value counts as a manual (locked) choice
      if(p.orient==='portrait' || p.orient==='verticale'){ state.orientamento='portrait'; state.orientTouched=true; }
      else if(p.orient==='landscape' || p.orient==='orizzontale'){ state.orientamento='landscape'; state.orientTouched=true; }
      else { state.orientamento='landscape'; state.orientTouched=false; }
      updateOrientUI();
      render();
      updatePreview();
      // land on the first step still to complete
      var hasReq = steps.some(function(s){ return s.hasAttribute('data-req'); });
      var target = steps.length-1;
      if(hasReq){
        for(var i=0;i<steps.length;i++){ var r=steps[i].getAttribute('data-req'); if(r && !state[r]){ target=i; break; } }
      } else {
        if(!state.size) target = firstStep;
        else if(!state.qty) target = firstStep+1;
      }
      showStep(target);
    }
  };

  showStep((state.tipo==='dtf'||state.tipo==='stampataglio') ? 1 : 0);
  setupVinylSwatches();
  render();
  updatePreview();
  updateOrientUI();

  // Re-price live when the admin app ("Prezzi Sticker") saves new rules in another tab.
  window.addEventListener('storage', function(e){
    if(e.key === 'wowPricingRules'){ render(); }
  });
})();
